<template>
  <div>
    <div class="d-flex" id="wrapper">
        <!-- Sidebar -->
        <SideBar/>
        <!-- /#sidebar-wrapper -->
        <!-- Page Content -->
        <div id="page-content-wrapper">
            <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
                <div>
                    <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                    </button>

                    <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                    </button>
                </div>

                <div class="d-flex">
                    <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
                    <p class="text-muted mb-0 hover-cursor link" @click="toLesseePage">&nbsp;Lessee&nbsp;</p>
                    <p class="text-primary mb-0 hover-cursor">/&nbsp;Details</p>
                </div>

                
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {{ admin }}
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </nav>
            <div class="container-fluid">
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-6 col-md-12 col-sm-12">
                                    <table>
                                        <tr>
                                            <th colspan="3" class="py-2">
                                                <h5> Company Info
                                                <span class="link ml-2" @click="toggleEditCompanyInfo"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span></h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>Name (Akta)</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ companyName }} <span v-if="newCompany" class="badge badge-primary">NEW</span> <img v-if="companyStatus == 8" src="~@/assets/images/icon-verified.png" alt="Brand Logo" class="icon-verified septian-font"></td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Name (NPWP)</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>
                                            {{ companyNameNPWP || '-' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Province</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ companyProvince }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">City</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ companyCity }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">District</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td>{{ companyDistrict }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Village</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyVillage }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Zip Code</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyZip }}</td>
                                        </tr>
                                        <tr>
                                            <td class="align-top">Address</td>
                                            <td class="align-top">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyAddress }}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyPhone }}</td>
                                        </tr>
                                        <tr>
                                            <td>Citizenship</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px; text-transform: uppercase;">{{ citizenship }}</td>
                                        </tr>
                                        <tr>
                                            <td v-if="citizenship == 'wni'">KTP Director</td>
                                            <td v-else>Passport Director</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyKtpPassportNumber }}</td>
                                        </tr>
                                        <tr>
                                            <td>NPWP</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyNPWP16 }}</td>
                                        </tr>
                                        <tr>
                                            <td>NITKU</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ companyNPWP22 }}</td>
                                        </tr>
                                        <tr>
                                            <td style="align-content: start;">Akta Address</td>
                                            <td style="align-content: start;">&emsp;:&emsp;</td>
                                            <td style="word-wrap: break-word; max-width:200px;">{{ aktaAddress }}</td>
                                        </tr>
                                        <tr>
                                            <td>Source</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ source }}</td>
                                        </tr>
                                        <tr>
                                            <th colspan="3" class="py-2">
                                                <button class="btn-warning form-control btn" @click="openModalOne('Remarks')">Remarks</button>
                                            </th>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-lg-4 col-md-9 col-sm-12">
                                    <table>
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5> Company Person In Charge (PIC) <span class="link ml-2" @click="openModal('EditPIC')"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span></h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td width="30%">Name</td>
                                            <td width="10%">&emsp;:&emsp;</td>
                                            <td width="60%">{{ userName }}</td>
                                        </tr>
                                        <tr>
                                            <td>Phone</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userPhone }}</td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userEmail }}</td>
                                        </tr>
                                        <tr>
                                            <td>Position</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userPosition }}</td>
                                        </tr>
                                        <tr>
                                            <td>Division</td>
                                            <td>&emsp;:&emsp;</td>
                                            <td>{{ userDivision }}</td>
                                        </tr>
                                    </table>
                                    <table class="mt-3">
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5>ASANI Person In Charge (PIC) <span class="link ml-2" @click="openModal('EditAsaniPIC')"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span></h5>
                                            </th>
                                        </tr>
                                         <tr>
                                            <td width="30%">Name</td>
                                            <td width="10%">&emsp;:&emsp;</td>
                                            <td v-if="asaniEmployeeName != '' && asaniEmployeeName != null">{{ asaniEmployeeName }}</td>
                                            <td width="60%" v-else>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                        </tr>                                        
                                    </table>
                                    <table class="mt-3">
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5>Finance <span @click.prevent="openModalFinance" class="link ml-2"><i class="fas fa-edit" data-toggle="tooltip" title="Edit" ></i></span></h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td width="30%">Email</td>
                                            <td width="10%">&emsp;:&emsp;</td>
                                            <td width="60%">
                                                <div v-for="(email, index) in financeEmailInfo" :key="`financeEmail-${index}`">{{email}}</div>
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-3">
                                        <tr>
                                            <th colspan="3" class="py-2"> 
                                                <h5>Sales Status <span class="link ml-2" @click="openModal('EditSalesStatus')"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span></h5>
                                            </th>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span v-if="salesStatus == 1" class="badge badge-success">On Prospect</span>
                                                <span v-if="salesStatus == 2" class="badge badge-primary">On Going</span>
                                                <span v-if="salesStatus == 0" class="badge badge-warning">On Hold</span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-lg-2 col-md-3 col-sm-12">
                                    <div class="py-1" v-if="companyLogoUrl">
                                        <img class="img-logo" :src="companyLogoUrl">
                                    </div>
                                </div>
                            </div>
                            <div class="row py-3"></div>
                            <div class="row">
                                <div class="col-12">
                                    <h5>Verifications</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <table>
                                        <tr>
                                            <td v-if="companyStatus != 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-primary btn-sm" @click="cekAsaniPic" :class="{'btn-success' : (lastStatus == 1 || lastStatus == 99)}">Contacting</button>
                                            </td>
                                            <td v-if="companyStatus == 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-secondary btn-sm" @click="cekAsaniPic">Contacting</button>
                                            </td>

                                            <td v-if="companyStatus != 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-primary btn-sm" @click="openModal('Meeting')" :class="{'btn-success' : (lastStatus == 1 || lastStatus == 99)}">Meeting</button>
                                            </td>
                                            <td v-if="companyStatus == 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-secondary btn-sm" @click="openModal('Meeting')">Meeting</button>
                                            </td>

                                            <td v-if="companyStatus != 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-sm" @click="openModal('UploadLegalDocument')" :class="{'btn-success':(docApprove == 5),'btn-primary':(docApprove < 5)}">KYC Legal Doc ({{docApprove}}/5)</button>
                                            </td>
                                            <td v-if="companyStatus == 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-secondary btn-sm" @click="openModal('UploadLegalDocument')">KYC Legal Doc ({{docApprove}}/5)</button>
                                            </td>

                                            <td v-if="companyStatus != 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-primary btn-sm" @click="openModal('SendAgreement')" v-if="(companyStatus <= 5 && agreementCount == 0) || companyStatus == 99" :class="{'btn-primary': (agreementStatus == 0),'btn-success': (agreementStatus == 1)}"> Send Agreement </button>
                                                <button style="width:100%;" class="btn btn-primary btn-sm" @click="openModal('ProcessAgreement')" v-if="companyStatus >= 6 && agreementCount > 0" :class="{'btn-primary': (agreementStatus == 0),'btn-success': (agreementStatus == 1)}"> Process Agreement ({{agreementCount}}) </button>
                                            </td>
                                            <td v-if="companyStatus == 99" width="20%" style="padding-right:10px;">
                                                <button style="width:100%;" class="btn btn-secondary btn-sm" @click="openModal('SendAgreement')" v-if="(agreementCount == 0)"> Send Agreement </button>
                                                <button style="width:100%;" class="btn btn-secondary btn-sm" @click="openModal('ProcessAgreement')" v-if="companyStatus >= 6 && agreementCount > 0"> Process Agreement ({{agreementCount}}) </button>
                                            </td>

                                            <td width="20%">
                                                <button style="width:100%;" class="btn btn-primary btn-sm" @click="openModal('UpdateStatus')" v-if="companyStatus != 8 && companyStatus != 99">Update Status</button>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                           
                            <div class="row mt-2" v-if="companyStatus == 99">
                                <div class="col-12">
                                    <h6 class="font-red">Reason : {{rejectCompanyReason}} </h6>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-12">
                                    <h5>Documents</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <table class="table-responsive-sm">
                                        <tr>
                                            <td colspan="3">Company Documents</td>
                                            <td colspan="2" v-if="citizenship == 'wni'">KTP Director</td>
                                            <td colspan="2" v-else>Passport Director</td>
                                        </tr>
                                         <tr>
                                            <td style="padding-right:10px;">
                                                <button class="btn btn-primary btn-sm" disabled v-if="NPWPUrl == '' || NPWPUrl == null"> Download NPWP/SKT</button>
                                                <a :href="NPWPUrl+'?token=' + jwt" target="_blank" class="btn btn-primary btn-sm" v-else> Download NPWP/SKT</a>
                                                <br>
                                                <label class="edit-status"> Status : </label>
                                                <a v-if="loadingStatusNPWP == true"> 
                                                    <span class="link-biru"><img src="~@/assets/images/load-button.gif"></span>
                                                </a> 
                                                <a @click="openModal('DocPending', 'NPWP/SKT', NPWPStatus)" v-if="NPWPStatus == 0 && loadingStatusNPWP == false" > 
                                                    <span class="link-biru"> pending</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'NPWP/SKT',NPWPStatus)" v-else-if="NPWPStatus == 1 && loadingStatusNPWP == false"> 
                                                    <span class="link-biru"> Approved</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'NPWP/SKT',NPWPStatus)" v-else-if="NPWPStatus == 2 && loadingStatusNPWP == false"> 
                                                    <span class="link-biru"> Rejected</span>
                                                </a><br>
                                                <span class="link" @click="toggleOpenChangeNPWPDoc" v-if="companyStatus != 99"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span>
                                            </td>
                                            <td style="padding-right:10px;">
                                                <button class="btn btn-primary btn-sm" disabled v-if="siupUrl == '' || siupUrl == null"> Download SIUP </button>
                                                <a :href="siupUrl+'?token=' + jwt" target="_blank" class="btn btn-primary btn-sm" v-else> Download SIUP </a>
                                                <br>
                                                <label class="edit-status"> Status : </label>
                                                <a v-if="loadingStatusSiup == true"> 
                                                    <span class="link-biru"><img src="~@/assets/images/load-button.gif"></span>
                                                </a> 
                                                <a @click="openModal('DocPending', 'SIUP', siupStatus)" v-if="siupStatus == 0 && loadingStatusSiup == false" > 
                                                    <span class="link-biru"> pending</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'SIUP',siupStatus)" v-else-if="siupStatus == 1 && loadingStatusSiup == false"> 
                                                    <span class="link-biru"> Approved</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'SIUP',siupStatus)" v-else-if="siupStatus == 2 && loadingStatusSiup == false"> 
                                                    <span class="link-biru"> Rejected</span>
                                                </a><br>
                                                <span class="link" @click="openModal('ChangeDocument','SIUP')" v-if="companyStatus != 99"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span>
                                            </td>
                                            <td style="padding-right:10px;">
                                                <div class="dropdown">
                                                    <button class="dropdown-toggle btn btn-primary btn-sm" id="dropdownAkta" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="aktaUrl == null || aktaUrl == ''">
                                                         Download Akta
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownAkta">
                                                        <a class="dropdown-item link" :href="aktaUrl+'?token=' + jwt" target="_blank">Pendirian</a>
                                                        <a v-if="aktaPerubahanUrl.length > 0" class="dropdown-item link" :href="aktaPerubahanUrl+'?token=' + jwt" target="_blank">Perubahan</a>
                                                    </div>
                                                </div>
                                                <!-- <br> -->
                                                <label class="edit-status"> Status : </label>
                                                <a v-if="loadingStatusAkta == true"> 
                                                    <span class="link-biru"><img src="~@/assets/images/load-button.gif"></span>
                                                </a> 
                                                <a @click="openModal('DocPending', 'Akta', aktaStatus)" v-if="aktaStatus == 0 && loadingStatusAkta == false" > 
                                                    <span class="link-biru"> pending</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'Akta', aktaStatus)" v-else-if="aktaStatus == 1 && loadingStatusAkta == false"> 
                                                    <span class="link-biru"> Approved</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'Akta', aktaStatus)" v-else-if="aktaStatus == 2 && loadingStatusAkta == false"> 
                                                    <span class="link-biru"> Rejected</span>
                                                </a><br>
                                                <span class="link" @click="openModal('ChangeDocument','Akta')" v-if="companyStatus != 99"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span>
                                            </td>

                                            <td style="padding-right:10px;">
                                                <button class="btn btn-primary btn-sm"  disabled v-if="companyKTPUrl == null || companyKTPUrl == ''">{{ citizenship == 'wni' ? "Download KTP" : "Download Passport" }}</button>
                                                <a :href="companyKTPUrl+'?token=' + jwt" target="_blank" class="btn btn-primary btn-sm" v-else> {{ citizenship == 'wni' ? "Download KTP" : "Download Passport" }}</a>
                                                <br>
                                                <label class="edit-status"> Status : </label> 
                                                <a v-if="loadingStatusKTP == true"> 
                                                    <span class="link-biru"><img src="~@/assets/images/load-button.gif"></span>
                                                </a> 
                                                <a @click="openModal('DocPending', 'KTP', companyKTPStatus)" v-if="companyKTPStatus == 0 && loadingStatusKTP == false"> 
                                                    <span class="link-biru"> pending</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'KTP',companyKTPStatus)" v-else-if="companyKTPStatus == 1 && loadingStatusKTP == false"> 
                                                    <span class="link-biru"> Approved</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'KTP',companyKTPStatus)" v-else-if="companyKTPStatus == 2 && loadingStatusKTP == false"> 
                                                    <span class="link-biru"> Rejected</span>
                                                </a><br>
                                                <span class="link" @click="openModal('ChangeDocument','KTP')" v-if="companyStatus != 99"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span>
                                            </td>
                                            <td>
                                                <div class="dropdown">
                                                    <button class="dropdown-toggle btn btn-primary btn-sm" id="dropdownAkta" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="SKUrl == null || SKUrl == ''">
                                                        Download SK Menkumham
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownAkta">
                                                        <a class="dropdown-item link" :href="SKUrl+'?token=' + jwt" target="_blank">Pendirian</a>
                                                        <a v-if="SKPerubahanUrl.length > 0" class="dropdown-item link" :href="SKPerubahanUrl+'?token=' + jwt" target="_blank">Perubahan</a>
                                                    </div>
                                                </div>                                                    
                                                <label class="edit-status"> Status : </label> 
                                                <a v-if="loadingStatusSK == true"> 
                                                    <span class="link-biru"><img src="~@/assets/images/load-button.gif"></span>
                                                </a> 
                                                <a @click="openModal('DocPending', 'SK Menkumham', SKStatus)" v-if="SKStatus == 0 && loadingStatusSK == false"> 
                                                    <span class="link-biru"> pending</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'SK Menkumham',SKStatus)" v-else-if="SKStatus == 1 && loadingStatusSK == false"> 
                                                    <span class="link-biru"> Approved</span>
                                                </a>
                                                <a @click="openModal('DocPending', 'SK Menkumham',SKStatus)" v-else-if="SKStatus == 2 && loadingStatusSK == false"> 
                                                    <span class="link-biru"> Rejected</span>
                                                </a><br>
                                                <span class="link" @click="openModal('ChangeDocument','SK Menkumham')" v-if="companyStatus != 99"><i class="fas fa-edit" data-toggle="tooltip" title="Edit"></i></span>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                              
                             
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <h5 class="card-title">Log Action</h5>
                            <div class="card">
                                <div class="card-body">
                                    <table class="fixed_header table-bordered table-striped">
                                        <tbody class="full-width">
                                            <tr>
                                               <th width="25%">When</th>
                                                <th width="45%">What</th>
                                                <th width="30%">Who</th>
                                            </tr>
                                            <tr v-if="dataLog.length == 0">
                                                <td colspan="3" style="text-align:center;">Tidak ada Log</td>
                                            </tr>
                                            <tr v-else v-for="(data, index) in dataLog" :key="`log-${index}`">
                                                <td> {{ data.time }}</td>
                                                <td> {{ data.text }}</td>
                                                <td> {{ data.ids }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-end flex-wrap">
                                    <div class="d-flex">
                                        <h5 class="card-title"> Admin </h5>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Phone Number</th>
                                                <th>Email</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Siapa</td>
                                                <td>0898978xxxx</td>
                                                <td>
                                                    Solahudin795@gmail.com
                                                </td>
                                                <td>
                                                    <button class="btn btn-primary btn-sm link-white" > Hapus </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="container"> -->
                <!-- <div class="row mr-1 ml-2"> -->
                        <!-- <div class=""> -->
                            <!-- <div class="container"> -->
                            
                        <!-- </div> -->
                    <!-- </div> -->
                <!-- </div> -->
                <!-- </div> -->
                <div class="row mr-1">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-end flex-wrap">
                                    <div class="d-flex">
                                        <h5 class="card-title">Order History </h5> 
                                        <h6 class="ml-2 pt-1 prod-rent"> (Product Renting : {{ productRenting }})</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <table class="table table-sm table-bordered table-striped table-responsive-sm" style="margin-bottom: 0px;">
                                        <thead class="full-width">
                                            <tr>
                                                <th>Order ID</th>
                                                <!-- <th>PIC</th> -->
                                                <th>Submit Date</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="loadingTable == true">
                                                <td colspan="4" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                            </tr>
                                            <tr v-else-if="historyOrder == ''">
                                                <td colspan="4" class="text-center">Data not available</td>
                                            </tr>
                                            <tr v-for="(data, index) in historyOrder" :key="`orderHist-${index}`" v-else>
                                                <td>{{ data.orderCode }}</td>
                                                <!-- <td>PIC Name</td> -->
                                                <td>{{ data.submitDate }}</td>
                                                <td v-if="data.status == 0"><label class="badge badge-secondary">Pending</label></td>
                                                <td v-if="data.status == 1"><label class="badge badge-warning">On Process</label></td>
                                                <td v-if="data.status == 2"><label class="badge badge-warning">Quotation Review</label></td>
                                                <td v-if="data.status == 3"><label class="badge badge-warning">Documents Verified</label></td>
                                                <td v-if="data.status == 4"><label class="badge badge-warning">Agreement Review</label></td>
                                                <td v-if="data.status == 5"><label class="badge badge-warning">Waiting for Payment</label></td>
                                                <td v-if="data.status == 6"><label class="badge badge-warning">Ready to Book</label></td>
                                                <td v-if="data.status == 7"><label class="badge badge-warning">Ready to Pickup</label></td>
                                                <td v-if="data.status == 8"><label class="badge badge-warning">Picking Up</label></td>
                                                <td v-if="data.status == 9"><label class="badge badge-warning">Ready to Prepare</label></td>
                                                <td v-if="data.status == 10"><label class="badge badge-warning">Prepared</label></td>
                                                <td v-if="data.status == 11"><label class="badge badge-info">Ready to Deliver</label></td>
                                                <td v-if="data.status == 12"><label class="badge badge-success">Shipping</label></td>
                                                <td v-if="data.status == 13"><label class="badge badge-success">Renting</label></td>
                                                <td v-if="data.status == 14"><label class="badge badge-success">Finished</label></td>
                                                <td v-if="data.status == 15"><label class="badge badge-success">Return Scheduled</label></td>
                                                <td v-if="data.status == 16"><label class="badge badge-info">Return Assign</label></td>
                                                <td v-if="data.status == 17"><label class="badge badge-success">Return Match</label></td>
                                                <td v-if="data.status == 18"><label class="badge badge-danger">Return Unmatch</label></td>
                                                <td v-if="data.status == 19"><label class="badge badge-success">Completed</label></td>
                                                <td v-if="data.status == 99"><label class="badge badge-danger">Cancelled</label></td>
                                                <td><button class="btn btn-primary btn-sm" @click="toDetail(data.orderId, data.orderCode, data.companyId)"> Detail </button></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mr-1" v-if="lesseeAdmin != ''">
                    <div class="col-md-12 grid-margin stretch-card card-div">
                        <div class="container">
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-end flex-wrap">
                                    <div class="d-flex">
                                        <h5 class="card-title">Registered Admin</h5> 
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-body">
                                    <table class="table table-sm table-bordered table-striped table-responsive-sm">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <!-- <th>PIC</th> -->
                                                <th>Phone Number</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="loadingTable == true">
                                                <td colspan="4" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                                            </tr>
                                            <tr v-for="(data,index) in lesseeAdmin" :key="`leseeAdmin-${index}`" v-else>
                                                <td>{{ data.lesseeName }}</td>
                                                <td>{{ data.lesseePhoneNumber }}</td>
                                                <td>{{ data.lesseeEmail }}</td>
                                                <td><span class="badge badge-success" v-if="data.status == '1'">Assigned</span><span class="badge badge-warning" v-if="data.status == '2'">Revoked</span><span class="badge badge-warning" v-if="data.status == '3'">Suspended</span></td>
                                                <!-- <td><button class="btn btn-primary btn-sm" @click="toDetail(data.orderId, data.orderCode, data.companyId)"> Detail </button></td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /#page-content-wrapper -->
    </div>
    <!-- ModalFinance -->
    <div class="modal fade" id="modalFinance" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div class="change-title">
                            <h4 class="modal-title">Finance</h4>
                        </div>
                        <button type="button" class="close" data-dismiss="modal" @click="cancelChangeFinanceEmail">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(email,i) in financeEmail" :key="i" class="one-line">
                            <label class="ol-label"> Email {{i+1}} </label>
                            <label class="ol-titik2">:</label>
                            <div class="container">
                                <div class="row align-items-center">
                                    <div :class="i > 0 ? 'col-lg-11 pl-0 pr-1' : 'col-lg-12 px-0' ">
                                        <input type="text" :class="{ 'form-control': true,'border-red' : errorFinanceEmail.indexOf(financeEmail[i]) !== -1}" name="depositDate" v-model="financeEmail[i]">
                                    </div>
                                    <div class="col-lg-1 px-0" v-if="i !== 0">
                                        <button @click="deleteFinanceEmail(financeEmail[i])" class="btn btn-secondary btn-sm py-1 w-100">-</button>
                                    </div>
                                </div>
                                <p v-if="errorFinanceEmail.indexOf(financeEmail[i]) !== -1" class="text-danger m-0 p-0" style="transform: translateX(-16px); font-size: 12px">Email is not valid</p>
                            </div>
                        </div>
                        <div class="one-line">
                            <label class="ol-label"> Email {{financeEmail.length+1}} </label>
                            <label class="ol-titik2">:</label>
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-11 pl-0 pr-1">
                                        <input type="text" name="depositDate" :class="{ 'form-control': true,'border-red' : errorAddFinanceEmail}" v-model="addFinanceEmail">
                                    </div>
                                    <div class="col-lg-1 px-0">
                                        <button @click="addMoreFinanceEmail" class="btn btn-secondary btn-sm py-1 w-100">+</button>
                                    </div>
                                </div>
                                <p v-if="errorAddFinanceEmail" class="text-danger m-0 p-0" style="transform: translateX(-16px); font-size: 12px">Email is not valid</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="cancelChangeFinanceEmail" v-if="companyStatus != 99">Cancel</button>
                        <button type="button" class="btn btn-primary btn-sm" @click="submitChangeFinance" v-if="!loadingButtonSave && companyStatus != 99" :disabled="allEmailFilled == false">Save</button>
                        <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && companyStatus != 99"><img src="~@/assets/images/2.gif" style="height: 18px;" />Save</button>
                    </div>
                </div>
            </div>
    </div>
    <!-- modalEditCompany -->
    <div class="modal fade" id="modalEditPIC" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Edit Company Person In Charge (PIC)</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <!-- <div class="one-line">
                        <label class="ol-label"> Name </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Phone </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserPhone" @keypress="isNumber($event)" placeholder="Ex :628xxxxxxxxxxxx">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Email </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserEmail">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Position </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserPosition">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Division </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="qty" class="form-control form-control-sm" v-model="editUserDivision">
                    </div> -->
                    <div class="one-line">
                        <label class="ol-label"> Name </label>
                        <label class="ol-titik2">:</label>
                        <multiselect v-model="choosePic" :options="lesseeSelect" label="lesseeName" track-by="lesseeName" :allow-empty="false" deselect-label="Can't remove this value" placeholder="Select Lessee PIC"></multiselect>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" :disabled="!choosePic.lesseeId || choosePic.lesseeId == oldPic" @click="submitEditPic" v-if="loadingButtonSave == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
                </div>
            </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- Modal Edit-->
    <div class="modal fade" id="modalDelete" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Delete Admin</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to delete Admin (ini nama admin) ?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm">Save</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
    <!-- modalReject -->
      <div class="modal fade" id="modalChangeDocument" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change Document {{ docPilih === "KTP" && citizenship == "wna"? 'Passport': docPilih }}</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line" v-if="docPilih == 'Akta'">
                    <label class="ol-label"> Pilih Akta </label>
                    <label class="ol-titik2">:</label>
                    <select v-model="aktaType" class="form-control-sm form-control" name="selectAkta" id="selectAkta">
                        <option value="1">Pendirian</option>
                        <option value="2">Pendirian & Perubahan</option>
                    </select>
                </div>
                <div class="one-line" v-if="docPilih == 'SK Menkumham'">
                    <label class="ol-label"> Pilih SKM </label>
                    <label class="ol-titik2">:</label>
                    <select v-model="skmType" class="form-control-sm form-control" name="selectSKM" id="selectAkta">
                        <option value="1">Pendirian</option>
                        <option value="2">Pendirian & Perubahan</option>
                    </select>
                </div>
                <div class="one-line" v-if="docPilih !== 'Akta' && docPilih !== 'SK Menkumham'">
                    <label class="ol-label-file"> Document File </label>
                    <label class="ol-titik2-file">:</label>
                    <input type="file" :ref="docPilih" name="" id="change_document" @change="onFilePicked($event, docPilih)">
                </div>
                <div class="one-line" v-if="docPilih == 'Akta'">
                    <label class="ol-label-file"> Akta Pendirian </label>
                    <label class="ol-titik2-file">:</label>
                    <input type="file" ref="Akta" name="" id="change_document_pendirian" @change="onFilePicked($event, 'Akta')">
                </div>
                <div class="one-line" v-if="docPilih == 'Akta' && aktaType == 2">
                    <label class="ol-label-file"> Akta Perubahan </label>
                    <label class="ol-titik2-file">:</label>
                    <input type="file" ref="Akta Perubahan" name="" id="change_document_perubahan" @change="onFilePicked($event, 'Akta Perubahan')">
                </div>
                <div class="one-line" v-if="docPilih == 'SK Menkumham'">
                    <label class="ol-label-file"> SKM Pendirian </label>
                    <label class="ol-titik2-file">:</label>
                    <input type="file" ref="SK Menkumham" name="" id="change_document_pendirian" @change="onFilePicked($event, 'SK Menkumham')">
                </div>
                <div class="one-line" v-if="docPilih == 'SK Menkumham' && skmType == 2">
                    <label class="ol-label-file"> SKM Perubahan </label>
                    <label class="ol-titik2-file">:</label>
                    <input type="file" ref="SK Menkumham Perubahan" name="" id="change_document_perubahan" @change="onFilePicked($event, 'SK Menkumham Perubahan')">
                </div>
                <div class="one-line" v-if="docPilih == 'Akta'">
                    <label class="ol-label"> Address </label>
                    <label class="ol-titik2">:</label>
                    <input type="text" class="form-control-sm form-control" name="akta" v-model="aktaAdressInput">
                </div>
                <div class="one-line" v-if="docPilih == 'KTP'">
                    <label class="ol-label"> {{ citizenship == 'wni'? "No. KTP": "No. Passport"}} </label>
                    <label class="ol-titik2">:</label>
                    <input type="text" class="form-control-sm form-control" name="ktp" @keypress="citizenship == 'wni'? isNumber($event): undefined" v-model="KTPNumber">
                </div>
                <div class="one-line">
                    <label class="ol-label"> Reason </label>
                    <label class="ol-titik2">:</label>
                    <textarea class="form-control form-control-sm" rows="3" v-model="noteChangeDocument" style="resize: none"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary btn-sm" @click="submitDoc" v-if="loadingButtonSave == false">Save</button>
                <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->

      <!-- MODAL DOCUMENTS -->
      <!-- Modal DocPending-->
    <div class="modal fade" id="modalDocPending" role="dialog">
        <div class="modal-dialog modal-xl modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Document {{ docPilih === "KTP" && citizenship === "wna"? "Passport" : docPilih }}</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <h5>History Documents</h5>
                    <table class="table table-sm table-bordered">
                        <tr>
                          <th>Status</th>
                          <th>Submit Date</th>
                          <th>Submit By</th>
                          <th>Action Date</th>
                          <th>Action By</th>
                          <th>Note</th>
                          <th>Files</th>
                        </tr>
                        <tr v-if="loadingTableDoc == true">
                            <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="loadingTable == false && historyDocData != ''" v-for="(data, index) in historyDocData" :key="`historyDoc-${index}`">
                          <td v-if="data.docStatus == 0"> Pending </td>
                          <td v-if="data.docStatus == 1"> Approve </td>
                          <td v-if="data.docStatus == 2"> Rejected </td>
                          <td>{{ data.submitDate }}</td>
                          <td>{{ data.submitBy }}</td>
                          <td><span v-if="data.docStatus != 0">{{ data.actionDate }}</span></td>
                          <td>{{ data.actionBy }}</td>
                          <td>{{ data.note }}</td>
                          <td><a :href="data.docUrl+'?token=' + jwt" target="_blank"> download </a></td>
                        </tr>
                        <tr v-else-if="loadingTable == false && historyDocData == ''">
                            <td colspan="7" class="text-center"> Data Not Available</td>
                        </tr>
                    </table>
                </div>
                <!-- <div class="one-line" v-if="docPilih == 'KTP' && companyKTPStatus == 0 && docStatus != 2">
                <label class="ol-label"> ID Number (KTP) </label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" @keypress="isNumber($event)" v-model="KTPNumber">
              </div>
              <div class="one-line" v-if="docPilih == 'KTP' && companyKTPStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0 && docStatus != 2">
                <label class="ol-label"> NPWP Number </label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" @keypress="isNumber($event)" v-model="NpwpDocInput">
              </div>
              <div class="one-line" v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'SIUP' && siupStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'Purchase Order' && purchaseStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'Akta' && aktaStatus == 0 && docStatus != 2">
                <label class="ol-label"> Akta Address </label>
                <label class="ol-titik2">:</label>
                <input type="text" class="form-control-sm form-control" name="ktp" v-model="aktaAdressInput">
              </div>
              <div class="one-line" v-if="docPilih == 'Akta' && aktaStatus == 0">
                <label class="ol-label"> Status</label>
                <label class="ol-titik2">:</label>
                <select class="form-control form-control-sm" v-model="docStatus">
                    <option value="0">None</option>
                    <option value="1">Approve</option>
                    <option value="2">Reject</option>
                </select>
              </div>
              <div class="one-line" v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0 && docStatus != 0">
                <label class="ol-label"> Reason</label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm" v-model="rejectReason"></textarea>
              </div>
              <div class="one-line" v-if="docPilih == 'SIUP' && siupStatus == 0 && docStatus != 0">
                <label class="ol-label"> Reason</label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm" v-model="rejectReason"></textarea>
              </div>
              <div class="one-line" v-if="docPilih == 'Purchase Order' && purchaseStatus == 0 && docStatus != 0">
                <label class="ol-label"> Reason</label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm" v-model="rejectReason"></textarea>
              </div>
              <div class="one-line" v-if="docPilih == 'Akta' && aktaStatus == 0 && docStatus != 0">
                <label class="ol-label"> Reason</label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm" v-model="rejectReason"></textarea>
              </div>
              <div class="one-line" v-if="docPilih == 'KTP' && companyKTPStatus == 0 && docStatus != 0">
                <label class="ol-label"> Reason</label>
                <label class="ol-titik2">:</label>
                <textarea class="form-control form-control-sm" v-model="rejectReason"></textarea>
              </div> -->
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="docPilih == 'KTP' && companyKTPStatus == 0">Cancel</button>
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0">Cancel</button>
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="docPilih == 'Akta' && aktaStatus == 0">Cancel</button>
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="docPilih == 'SIUP' && siupStatus == 0">Cancel</button>
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="docPilih == 'Purchase Order' && purchaseStatus == 0">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateDocStatus(docPilih,)" v-if="docPilih == 'KTP' && companyKTPStatus == 0 && loadingButtonProcess == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateDocStatus(docPilih,)" v-else-if="docPilih == 'NPWP/SKT' && NPWPStatus == 0 && loadingButtonProcess == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateDocStatus(docPilih,)" v-else-if="docPilih == 'SIUP' && siupStatus == 0 && loadingButtonProcess == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateDocStatus(docPilih,)" v-else-if="docPilih == 'Purchase Order' && purchaseStatus == 0 && loadingButtonProcess == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateDocStatus(docPilih,)" v-else-if="docPilih == 'Akta' && aktaStatus == 0 && loadingButtonProcess == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonProcess == true"><img src="~@/assets/images/2.gif" style="height: 24px;">Save</button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal Edit-->
    <div class="modal fade" id="modalContacting" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Contacting</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div v-if="lastStatus != 1 && lastStatus != 99 && companyStatus != 99">
                    <div class="one-line">
                        <label class="ol-label"> Choose Channel </label>
                        <label class="ol-titik2">:</label>
                        <select class="form-control form-control-sm" v-model="channel" placeholder="Choose Channel">
                            <option value="">Choose Channel</option>
                            <option value="Call">Call</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="Email">Email</option>
                        </select>
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Date </label>
                        <label class="ol-titik2">:</label>
                        <date-picker style="width: 100%" v-model="contactingDate" type="date" format="DD-MM-YYYY" placeholder="Select Date"></date-picker>
                        <!-- <input type="datetime-local" name="schedule" v-model="meetingSchedule" class="form-control form-control-sm"> -->
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> Note </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="note" class="form-control-sm form-control" v-model="noteContacting">
                    </div>
                </div>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                    <thead>
                        <tr>
                            <th>Attemp</th>
                            <th>Channel</th>
                            <th>Date</th>
                            <th>Action Date</th>
                            <th>Action By</th>
                            <th>Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loadingTable">
                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="dataContacting == '' && !loadingTable">
                            <td colspan="6" class="text-center">Data not available</td>
                        </tr>
                        <tr v-else v-for="(data,index) in dataContacting" :key="`contact-${index}`">
                            <td>{{ index+1 }}</td>
                            <td>{{ data.channel }}</td>
                            <td>{{ data.date }}</td>
                            <td>{{ data.actionDate }}</td>
                            <td>{{ data.actionBy }}</td>
                            <td>{{ data.note }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="lastStatus != 1 && lastStatus != 99 && companyStatus != 99">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitContacting" v-if="!loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
    <div class="modal fade" id="modalMeeting" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Meeting</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div v-if="lastStatus != 1 && lastStatus != 99 && companyStatus != 99">
                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label"> Status </label>
                        <label class="ol-titik2">:</label>
                        <select class="form-control form-control-sm" v-model="meetingStatus" placeholder="Choose Channel">
                            <option value="">Choose Status</option>
                            <option value="1">Done</option>
                            <option value="2">Reschedule</option>
                            <option value="99">Cancel</option>
                        </select>
                    </div>

                    <div class="one-line" v-if="lastStatus == null || meetingStatus == 2">
                        <label class="ol-label"> Set Schedule </label>
                        <label class="ol-titik2">:</label>
                        <date-picker style="width: 100%" v-model="meetingSchedule" type="datetime" format="DD-MM-YYYY HH:mm" placeholder="Select Date and Time"></date-picker>
                        <!-- <input type="datetime-local" name="schedule" v-model="meetingSchedule" class="form-control form-control-sm"> -->
                    </div>
                    <div class="one-line" v-if="(lastStatus != null || meetingStatus == 99) && meetingStatus != 1">
                        <label class="ol-label"> Reason </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="place" class="form-control-sm form-control" v-model="reasonMeeting">
                    </div>

                    <div class="one-line" v-if="lastStatus == null || meetingStatus == 2">
                        <label class="ol-label"> Place </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="place" class="form-control-sm form-control" v-model="meetingPlace">
                    </div>

                    <div class="one-line" v-if="lastStatus == null || meetingStatus == 2">
                        <label class="ol-label"> Note </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="note" class="form-control-sm form-control" v-model="noteMeeting">
                    </div>

                    <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                        <label class="ol-label">Meeting Address </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAddress"></textarea>
                    </div>

                    <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                        <label class="ol-label"> Agenda </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAgenda"></textarea>
                    </div>

                    
                    <div v-for="(input, index) in inputAsaniAttend" :key="index">
                        <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Asani Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="employeeName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="employeePosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Asani')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Asani',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div v-for="(input, index) in inputClientAttend" :key="`client-${index}`" >
                        <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Client Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="clientName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="clientPosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Client')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Client',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div class="one-line" v-if="lastStatus != null && meetingStatus == 1">
                        <label class="ol-label"> Company Profile </label>
                        <label class="ol-titik2">:</label>
                        <div class="row" style="width: 100%; margin-left: 0px; padding-left: 0px">
                            <div class="col-12" style="display: flex; margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="companySince" style="width: 30%" placeholder="Founded since" @keypress="isNumber($event)">
                                <input type="text" name="reason" class="form-control-sm form-control ml-3" v-model="totalEmployeeClient" style="width: 30%" placeholder="Number of employee" @keypress="isNumber($event)"> 
                            </div>
                            <div class="col-12 mt-2" style="margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="industryType" style="width: 30%" placeholder="Industry type">
                            </div>
                        </div>
                    </div>

                    <div v-if="lastStatus != null && meetingStatus == 1" class="mt-3">
                        <label class="ol-label"> Meeting Result </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="meetingResult"></textarea>
                    </div>

                    <div v-if="lastStatus != null && meetingStatus == 1" class="mt-3">
                        <label class="ol-label"> List to do Asani </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="listToDo"></textarea>
                    </div>
                    <div v-if="lastStatus != null && meetingStatus == 1" class="mt-3">
                        <label class="ol-label"> Visit Documentation </label>
                        <br>
                        <input type="file" id="visit_0" name="" class="mt-2 form-control-file" @change="onFileDocPicked($event,0)">
                        <input type="file" id="visit_1" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,1)">
                        <input type="file" id="visit_2" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,2)">
                        <input type="file" id="visit_3" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,3)">
                        <input type="file" id="visit_4" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,4)">
                    </div>
                </div>
                <div v-if="editMeeting">
                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label">Meeting Address </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAddress"></textarea>
                    </div>

                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label"> Agenda </label>
                        <label class="ol-titik2">:</label>
                        <textarea class="form-control" rows="3" style="resize: none" v-model="meetingAgenda"></textarea>
                    </div>

                    
                    <div v-for="(input, index) in inputAsaniAttend" :key="index">
                        <div class="one-line" v-if="lastStatus != null">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Asani Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="employeeName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="employeePosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Asani')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Asani',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div v-for="(input, index) in inputClientAttend" :key="`client-${index}`">
                        <div class="one-line" v-if="lastStatus != null">
                            <label class="ol-label"> 
                                <span v-if="index == 0"> Client Attendant </span>
                            </label>
                            <label class="ol-titik2">
                                <span v-if="index == 0">:</span>
                            </label>
                            <div style="width: 100%; display: flex;">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="clientName[index]" style="width: 30%" placeholder="Name"> as
                                <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="clientPosition[index]" style="width: 30%" placeholder="Position"> 
                                <button class="btn btn-sm btn-primary ml-2" @click="addAttend('Client')" v-if="index == 0"><i class="fas fa-plus"></i></button>
                                <button class="btn btn-sm btn-danger ml-2" @click="removeRow('Client',index)" v-if="index != 0"><i class="fas fa-trash"></i></button>
                            </div>
                        </div>
                    </div>

                    <div class="one-line" v-if="lastStatus != null">
                        <label class="ol-label"> Company Profile </label>
                        <label class="ol-titik2">:</label>
                        <div class="row" style="width: 100%; margin-left: 0px; padding-left: 0px">
                            <div class="col-12" style="display: flex; margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="companySince" style="width: 30%" placeholder="Founded since">
                                <input type="text" name="reason" class="form-control-sm form-control ml-3" v-model="totalEmployeeClient" style="width: 30%" placeholder="Number of employee"> 
                            </div>
                            <div class="col-12 mt-2" style="margin-left: 0px; padding-left: 0px">
                                <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="industryType" style="width: 30%" placeholder="Industry type">
                            </div>
                        </div>
                    </div>

                    <div v-if="lastStatus != null" class="mt-3">
                        <label class="ol-label"> Meeting Result </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="meetingResult"></textarea>
                    </div>

                    <div v-if="lastStatus != null" class="mt-3">
                        <label class="ol-label"> List to do Asani </label>
                        <br>
                        <textarea class="form-control" rows="5" style="resize: none" v-model="listToDo"></textarea>
                    </div>
                    <div v-if="lastStatus != null" class="mt-3">
                        <label class="ol-label"> Visit Documentation </label>
                        <br>
                        <input type="file" id="visit_0" name="" class="mt-2 form-control-file" @change="onFileDocPicked($event,0)">
                        <div v-if="visitDocumentation[0].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[0].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_1" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,1)">
                        <div v-if="visitDocumentation[1].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[1].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_2" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,2)">
                        <div v-if="visitDocumentation[2].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[2].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_3" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,3)">
                        <div v-if="visitDocumentation[3].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[3].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                        <input type="file" id="visit_4" name="" class="mt-1 form-control-file" @change="onFileDocPicked($event,4)">
                        <div v-if="visitDocumentation[4].fileUrl != ''">
                            <a class="link-biru" :href="visitDocumentation[4].fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                        </div>
                    </div>
                </div>
                <div v-if="lastStatus == 1 && !editMeeting">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseInfo" role="button" aria-expanded="false" aria-controls="collapseInfo">
                            <div class="float-left"> Info</div>
                            <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                            <div class="collapse" id="collapseInfo">
                                <div class="one-line" v-if="lastStatus == 1">
                                    <label class="ol-label">Meeting Address </label>
                                    <label class="ol-titik2">:</label>
                                    <textarea class="form-control" rows="3" style="resize: none" v-model="editMeetingAddress" readonly></textarea>
                                </div>

                                <div class="one-line" v-if="lastStatus == 1">
                                    <label class="ol-label"> Agenda </label>
                                    <label class="ol-titik2">:</label>
                                    <textarea class="form-control" rows="3" style="resize: none" v-model="editMeetingAgenda" readonly></textarea>
                                </div>

                                
                                <div v-for="(input, index) in editInputAsaniAttend" :key="index">
                                    <div class="one-line" v-if="lastStatus == 1">
                                        <label class="ol-label"> 
                                            <span v-if="index == 0"> Asani Attendant </span>
                                        </label>
                                        <label class="ol-titik2">
                                            <span v-if="index == 0">:</span>
                                        </label>
                                        <div style="width: 100%; display: flex;">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editEmployeeName[index]" style="width: 30%" placeholder="Name" readonly> as
                                            <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="editEmployeePosition[index]" style="width: 30%" placeholder="Position" readonly> 
                                        </div>
                                    </div>
                                </div>

                                <div v-for="(input, index) in editInputClientAttend" :key="`client-${index}`">
                                    <div class="one-line" v-if="lastStatus == 1">
                                        <label class="ol-label"> 
                                            <span v-if="index == 0"> Client Attendant </span>
                                        </label>
                                        <label class="ol-titik2">
                                            <span v-if="index == 0">:</span>
                                        </label>
                                        <div style="width: 100%; display: flex;">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editClientName[index]" style="width: 30%" placeholder="Name" readonly> as
                                            <input type="text" name="reason" class="form-control-sm form-control ml-1" v-model="editClientPosition[index]" style="width: 30%" placeholder="Position" readonly> 
                                        </div>
                                    </div>
                                </div>

                                <div class="one-line" v-if="lastStatus == 1">
                                    <label class="ol-label"> Company Profile </label>
                                    <label class="ol-titik2">:</label>
                                    <div class="row" style="width: 100%; margin-left: 0px; padding-left: 0px">
                                        <div class="col-12" style="display: flex; margin-left: 0px; padding-left: 0px">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editCompanySince" style="width: 30%" placeholder="Founded since" readonly>
                                            <input type="text" name="reason" class="form-control-sm form-control ml-3" v-model="editTotalEmployeeClient" style="width: 30%" placeholder="Number of employee" readonly> 
                                        </div>
                                        <div class="col-12 mt-2" style="margin-left: 0px; padding-left: 0px">
                                            <input type="text" name="reason" class="form-control-sm form-control mr-1" v-model="editIndustryType" style="width: 30%" placeholder="Industry type" readonly>
                                        </div>
                                    </div>
                                </div>
                            </div>
                </div>
                <div v-if="lastStatus == 1 && !editMeeting" class="mt-3">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseResult" role="button" aria-expanded="false" aria-controls="collapseResult">
                    <div class="float-left"> Meeting Result</div>
                    <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                    <div class="collapse" id="collapseResult">
                        <textarea class="form-control" rows="5" style="resize: none" v-model="editMeetingResult" readonly></textarea>
                    </div>
                </div>

                <div v-if="lastStatus == 1 && !editMeeting" class="mt-3">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseList" role="button" aria-expanded="false" aria-controls="collapseList">
                    <div class="float-left"> List to do Asani</div>
                    <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                    <div class="collapse" id="collapseList">
                        <textarea class="form-control" rows="5" style="resize: none" v-model="editListToDo" readonly></textarea>
                    </div>
                </div>
                <div v-if="lastStatus == 1 && !editMeeting" class="mt-3">
                    <div class="card" style="display: flow-root; padding: 5px" data-toggle="collapse" href="#collapseDocumentation" role="button" aria-expanded="false" aria-controls="collapseDocumentation">
                    <div class="float-left"> Visit Documentation </div>
                    <div class="float-right"><i class="fas fa-chevron-circle-down"></i></div>
                    </div>
                    <div class="collapse" id="collapseDocumentation" style="background-color: #E9ECEF; padding: 5px; border-radius: 5px;">
                        <div v-for="(data, index) in editVisitDocumentation" :key="`visitDoc-${index}`">
                            <div v-if="data.fileUrl != ''">
                                <a class="link-biru" :href="data.fileUrl+'?token=' + jwt" target="_blank">Lihat file</a>
                            </div>
                        </div>
                    </div>
                </div>
                <table class="table table-sm table-bordered table-striped table-responsive-sm mt-3">
                    <thead>
                        <tr>
                            <th>Attemp</th>
                            <th>Schedule Date</th>
                            <th>Action By</th>
                            <th>Place</th>
                            <th>Note</th>
                            <th>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loadingTable">
                            <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                        </tr>
                        <tr v-else-if="dataMeeting == '' && !loadingTable">
                            <td colspan="6" class="text-center">Data not available</td>
                        </tr>
                        <tr v-else v-for="(data,index) in dataMeeting" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ data.scheduleDate }}</td>
                            <td>{{ data.actionBy }}</td>
                            <td>{{ data.place }}</td>
                            <td>{{ data.note }}</td>
                            <td>{{ data.result }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" v-if="(lastStatus != 1 && lastStatus != 99 && companyStatus != 99) || (lastStatus == 1 && editMeeting)">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitMeeting" v-if="!loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && companyStatus == 2 && meetingStatus != 1">Save</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitMeeting" v-if="!loadingButtonSave && lastStatus == null">Save</button>

              <button type="button" class="btn btn-primary btn-sm" @click="submitMeeting" v-if="(!loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus == 2 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (!loadingButtonSave && lastStatus == 1 && editMeeting)">Save Draft</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="(loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && companyStatus == 2 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (loadingButtonSave && lastStatus == 1 && editMeeting)"><img src="~@/assets/images/2.gif" style="height: 18px;">Save Draft</button>

              <button type="button" class="btn btn-success btn-sm" @click="submitMeeting('send')" v-if="(!loadingButtonSaveSend && lastStatus != 1 && lastStatus != 99 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (!loadingButtonSaveSend && lastStatus == 1 && editMeeting)">Save & Send</button>
              <button type="button" class="btn btn-success btn-sm" disabled v-else-if="(loadingButtonSaveSend && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && lastStatus != null && meetingStatus != 2 && meetingStatus != 99 && meetingStatus != '') || (loadingButtonSaveSend && lastStatus == 1 && editMeeting)"><img src="~@/assets/images/2.gif" style="height: 18px;">Save & Send</button>

              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && lastStatus != 1 && lastStatus != 99 && companyStatus != 99 && companyStatus == 2 && meetingStatus != 1"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave && lastStatus == null"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
              <button type="button" class="btn btn-primary btn-sm" v-else-if="lastStatus == 1 && !editMeeting" @click="editMeetingData">Edit</button>
            </div>
          </div>
        </div>
    </div>
    <!-- endModal -->
      <!-- Modal Agreement-->
      <div class="modal fade" id="modalSendAgreement" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Send Agreement</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <p>Are you sure to send agreement to {{ companyName }}?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="sendAgreement('send')" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal process agreement -->
      <div class="modal fade" id="modalProcessAgreement" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Process Agreement</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Option</label>
                    <label class="ol-titik2">:</label>
                    <select class="form-control form-control-sm" v-model="chooseAgreementStatus">
                        <option value="1">Agreement Accepted</option>
                        <option value="2">Resend Agreement</option>
                    </select>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="sendAgreement('process')" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal process agreement -->
      <div class="modal fade" id="modalUpdateStatus" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Update Status</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Option</label>
                    <label class="ol-titik2">:</label>
                    <select class="form-control form-control-sm" v-model="chooseCompanyStatus">
                        <option value="8">Verified</option>
                        <option value="99">Rejected</option>
                    </select>
                </div>
                <div class="one-line" v-if="chooseCompanyStatus == 99">
                    <label class="ol-label"> Reason</label>
                    <label class="ol-titik2">:</label>
                    <multiselect v-model="rejectLesseeReason" :options="reasonSelect" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Reason" style="height: 5px;"></multiselect>
                </div>
                <div class="one-line" v-if="rejectLesseeReason == 'Other'">
                    <label class="ol-label">New Reason</label>
                    <label class="ol-titik2">:</label>
                    <input type="text" name="reason" v-model="newReason" class="form-control form-control-sm">
                </div>
                <div class="one-line" v-if="chooseCompanyStatus == 99">
                    <label class="ol-label">Note</label>
                    <label class="ol-titik2">:</label>
                    <textarea class="form-control" style="height: 90px; resize: none" v-model="rejectNotes"></textarea>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="updateStatus" v-if="loadingButtonProcess == false">Yes, Sure</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Yes, Sure</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <!-- Modal Edit-->
      <div class="modal fade" id="modalRemarks" role="dialog">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 1100px">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Remarks</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="card" style="border: none;">
                    <div class="card-body" style="padding: 0px;">
                        <table class="fixed_header table-bordered table-striped">
                            <tbody class="full-width">
                                <tr>
                                    <th style="min-width: 150px;">When</th>
                                    <th style="min-width: 500px;">What</th>
                                    <th>Who</th>
                                </tr>
                                <tr v-if="dataRemarks.length == 0">
                                    <td colspan="3">Tidak ada Log</td>
                                </tr>
                                <tr v-else v-for="(data, index) in dataRemarks" :key="index">
                                    <td> {{ data.time }}</td>
                                    <td> {{ data.text }}</td>
                                    <td> {{ data.ids }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                Note
                <input type="text" class="form-control-sm form-control" v-model="remarksNote">
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitRemarks" v-if="loadingButtonProcess == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
      <div class="modal fade" id="modalEditAsaniPIC" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change ASANI PIC</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Name </label>
                    <label class="ol-titik2">:</label>
                    <multiselect v-model="employeeAsani" :options="employeeSelect" label="employeeName" track-by="employeeName" :allow-empty="false" deselect-label="Can't remove this value" placeholder="Select Employee"></multiselect>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" :disabled="!employeeAsani.id || employeeAsani.id == oldPicAsani" @click="submitChangePicAsani" v-if="!loadingButtonSave">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
    </div>
    <div class="modal fade" id="modalEditSalesStatus" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Change Sales Status</h4> 
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="one-line">
                    <label class="ol-label"> Status </label>
                    <label class="ol-titik2">:</label>
                    <multiselect v-model="chooseSalesStatus" :options="salesStatusSelect" label="statusName" track-by="statusName" :allow-empty="false" deselect-label="Can't remove this value" placeholder="Select Status"></multiselect>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitChangeSalesStatus" v-if="!loadingButtonSave">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else-if="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;">Save</button>
            </div>
          </div>
        </div>
    </div>
    <ModalEditCompanyInfoLessee 
        :lesseeData="lesseeDetailData" 
        :triggerOpen="triggerOpenCompanyInfo" 
        @success-edit-company="handleSuccessEditCompany" 
    />
    <ModalChangeNPWPDoc
        :triggerOpen="triggerOpenChangeNPWPDoc"
        :companyId="companyId"
        :lesseeData="lesseeDetailData"
        :newCompany="newCompany !== null? newCompany : false"
        @success-change-document-npwp="handleSuccessChangeDocumentNPWP"
    />
    <ModalKYCLegalDoc
        :lesseeData="lesseeDetailData"
        :newCompany="newCompany !== null? newCompany : false"
        :companyId="companyId"
        :picId="picId"
        :citizenship="citizenship"
        @success-upload-legal-doc="handleSuccessUploadLegalDoc"
    />
  </div>
<!-- </div> -->
</template>

<script>
  import SideBar from '../SideBar'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import DatePicker from 'vue2-datepicker';
  // import 'vue2-datepicker/index.css';
  import validateMixin from '../../mixins/validate'
  import ModalEditCompanyInfoLessee from './Component/ModalEditCompanyInfoLessee.vue';
  import ModalChangeNPWPDoc from './Component/ModalChangeNPWPDoc.vue';
  import ModalKYCLegalDoc from './Component/ModalKYCLegalDoc.vue';

  export default {
    name: 'OrderDetailPage',
    mixins: [validateMixin],
    components: {
      SideBar, 
      Multiselect,
      DatePicker,
      ModalEditCompanyInfoLessee,
      ModalChangeNPWPDoc,
      ModalKYCLegalDoc
    },
    data() {
      return {
        spaceRegex: /[\u00A0\uFEFF\u202F]/g,
        remarksNote:'',
        dataRemarks:'',
        financeEmailInfo: [''],
        financeEmail: [''],
        addFinanceEmail: '',
        attachment: [],
        chooseSalesStatus:{
            status:'',
            statusName:''
        },
        salesStatusSelect:[
        {
            status:0,
            statusName:'On Hold'
        },
        {
            status:1,
            statusName:'On Prospect'
        },
        {
            status:2,
            statusName:'On Going'
        },],
        employeeAsani:{
            id:'',
            employeeName:''
        },
        oldAsaniPic: '',
        jwt: localStorage.getItem('jwt'),
        employeeSelect:[],
        rejectCompanyReason:'',
        rejectReason:'',
        NPWPFileName:"",
        NPWPFile:"",
        NPWPUrl:"",
        NPWPBase64:"",
        SIUPFileName:"",
        SIUPFile:"",
        SIUPUrl:"",
        SIUPBase64:"",
        aktaFileName:"",
        aktaFile:"",
        aktaUrl:"",
        aktaPerubahanFileName:"",
        aktaPerubahanFile:"",
        aktaPerubahanUrl:"",
        aktaBase64:"",
        aktaPerubahanBase64:"",
        KTPFileName:"",
        KTPFile:"",
        KTPUrl:"",
        KTPBase64:"",
        SKFileName:"",
        SKFile:"",
        SKUrl:"",
        SKPerubahanFileName:"",
        SKPerubahanFile:"",
        SKPerubahanUrl:"",
        SKBase64:"",
        SKPerubahanBase64:"",
        getNPWPName:'',
        getSiupName:'',
        getAktaName:'',
        getSKName:'',
        meetingStatus:'',
        meetingSchedule:'',
        contactingDate:'',
        meetingPlace:'',
        noteMeeting:'',
        reasonMeeting:'',
        dataMeeting:[],
        lastStatus:'',
        dataContacting:[],
        channel:'',
        noteContacting:'',
        lesseeAdmin:[],
        newCompany:null,
        dataOrder: [],
        columns: ['companyName', 'orderID'],
        totalPage:0,
        totalData:0,
        currentPage:1,
        viewDashboard: false,
        viewOrder: false,
        viewReturn: false,
        viewProduct: false,
        viewPairing: false,
        viewReconcile: false,
        viewResolution: false,
        viewLessor: false,
        viewLessee: false,
        viewEmployee: false,
        editOrder: false,
        editReturn: false,
        editProduct: false,
        editPairing: false,
        editReconcile: false,
        editResolution: false,
        editLessor: false,
        editLessee: false,
        editEmployee: false,
        loadingButtonSave:false,
        loadingButtonSaveSend:false,
        orderId:"",
        companyName:"",
        companyAddress:"",
        companyPhone:"",
        companyFax:"",
        picId:"",
        oldPic: '',
        userName:"",
        companyKtpPassportNumber:"",
        citizenship:"",
        userPhone:"",
        userEmail:"",
        userPosition:"",
        userDivision:"",
        editUserName:"",
        editUserKTP:"",
        editUserPhone:"",
        editUserEmail:"",
        editUserPosition:"",
        editUserDivision:"",
        statusOrder:"",
        KTPNumber:"",
        noteChangeDocument:"",
        companyLogoUrl:"",
        docStatus:0,
        companyKTPStatus:-1,
        companyKTPUrl:"",
        NPWPStatus:-1,
        siupStatus:-1,
        aktaStatus:-1,
        aktaPerubahanStatus:-1,
        SKStatus:-1,
        SKPerubahanStatus:-1,
        NPWPUrl:"",
        siupUrl:"",
        aktaUrl:"",
        purchaseUrl:"",
        admin:"",
        adminId:"",
        inputs:[],
        assignDeposit:0,
        productOrder:[],
        Deposit:0,
        docPilih:"",
        loadingButtonProcess:false,
        loadingButtonProcessNo:false,
        loadingTable:true,
        loadingTableAssign:false,
        loadingStatusKTP:true,
        loadingStatusNPWP:true,
        loadingStatusSiup:true,
        loadingStatusAkta:true,
        loadingStatusSK:true,
        loadingTableDoc:false,
        loadingTableEdit:false,
        lesseeId:"",
        historyDocData:[],
        documents: [],
        docFile:'',
        docFileName:'',
        docUrl:'',
        docBase64:'',
        productRenting:0,
        province:[],
        kabkot:[],
        kecamatan:[],
        editCompanyFax:'',
        editCompanyPhone:'',
        editSource:'',
        editCompanyAddress:'',
        editAktaAddress:'',
        editCompanyName:'',
        editCompanyNpwp:"",
        editProvince:'',
        editKabKot:'',
        editKecamatan:'',
        editKelurahan:'',
        editZip:'',
        apiProvince:'',
        apiKabKot:'',
        apiKecamatan:'',
        apiDataKecamatan:[],
        apiDataKabkot:[],
        companyProvince:'',
        companyDistrict:'',
        companyCity:'',
        companyVillage:'',
        companyZip:'',
        companyNPWP:"",
        companyNPWP16:"",
        companyNPWP22:"",
        aktaAddress:"",
        source:"",
        logCompany:[],
        logLessee:[],
        sourceSelect:[],
        newSource:'',
        docApprove:0,
        companyStatus:0,
        getAktaPerubahanName:'',
        getKtpName:'',
        getSKPerubahanName:'',
        agreementCount:null,
        agreementStatus:'',
        chooseAgreementStatus:'1',
        chooseCompanyStatus:'8',
        NpwpDocInput:'',
        aktaAdressInput:'',
        rejectLesseeReason:'',
        reasonSelect:[],
        newReason:'',
        rejectNotes:'',
        inputAsaniAttend:[''],
        inputClientAttend:[''],
        employeeName:[''],
        employeePosition:[''],
        clientName:[''],
        clientPosition:[''],
        meetingResult:'',
        listToDo:'',
        meetingAddress:'',
        meetingAgenda:'',
        companySince:'',
        totalEmployeeClient:'',
        industryType:'',
        editInputAsaniAttend:[''],
        editInputClientAttend:[''],
        editEmployeeName:[''],
        editEmployeePosition:[''],
        editClientName:[''],
        editClientPosition:[''],
        editMeetingResult:'',
        editListToDo:'',
        editMeetingAddress:'',
        editMeetingAgenda:'',
        editCompanySince:'',
        editTotalEmployeeClient:'',
        editIndustryType:'',
        editMeeting:false,
        visitDocumentation:[
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''}
        ],
        editVisitDocumentation:[
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''},
        {
            fileName:'',
            file:'',
            fileUrl:'',
            fileBase64:''}
        ],
        allEmailFilled: false,
        asaniEmployeeName:'',
        asaniPicPhone:'',
        historyOrder:[],
        salesStatus:'',
        choosePic:[],
        oldPic: '',
        oldPicAsani: '',
        lesseeSelect:[],
        dataLog:[],
        inputAktaPerubahan: '',
        inputSKPerubahan: '',
        aktaType: 1,
        skmType: 1,
        oldPic: '',
        oldPicAsani: '',
        errorFinanceEmail: [],
        errorAddFinanceEmail: false,
        lesseeDetailData: {},
        triggerOpenCompanyInfo: false,
        triggerOpenChangeNPWPDoc: false,

        companyNameNPWP: '',
      }
    },
    methods: {
        handleSuccessEditCompany({w,x,y}) {
            w.forEach((logType) => {
                this.sendLog(logType, x, y)
            })
            this.getData()
        },
        handleSuccessChangeDocumentNPWP() {
            this.sendLog(9,this.companyId,'company')
            this.getData()
        },
        handleSuccessUploadLegalDoc(logsType) {
            if (logsType && logsType.length > 0) {
                logsType.forEach((logType) => {
                    this.sendLog(logType, this.companyId, 'company')
                })
            }
            this.getData()
        },
        toggleEditCompanyInfo() {
            this.triggerOpenCompanyInfo = !this.triggerOpenCompanyInfo;
        },
        toggleOpenChangeNPWPDoc() {
            this.triggerOpenChangeNPWPDoc = !this.triggerOpenChangeNPWPDoc;
        },
        openModalFinance() {
            this.getData()
            $("#modalFinance").modal("show");
        },
        addMoreFinanceEmail() {
            if (this.errorAddFinanceEmail) {
                this.errorFinanceEmail = [...this.errorFinanceEmail, this.addFinanceEmail];
                this.errorAddFinanceEmail = false
            }
            this.financeEmail.push(this.addFinanceEmail.replace(this.spaceRegex, ' '))
            this.addFinanceEmail = "";
        },
        deleteFinanceEmail(data) {
            let newData = [];
            for (let i in this.financeEmail) {
                if (data !== this.financeEmail[i]) {
                newData.push(this.financeEmail[i]);
                }
            }
            this.financeEmail = newData;
            if (this.errorFinanceEmail.includes(data)) {
                this.errorFinanceEmail = this.errorFinanceEmail.filter((email) => email != data);
            }
        },
        isValidFinanceEmail() {
            let result = true
            if (this.addFinanceEmail && !this.validateEmail(this.addFinanceEmail)) {
                this.errorAddFinanceEmail = true
                result = false        
            }
            const invalidEmail = this.financeEmail.filter((email) => !this.validateEmail(email));
            if (invalidEmail.length > 0) {
                this.errorFinanceEmail = invalidEmail
                result = false
            }
            return result
        },
        cancelChangeFinanceEmail() {
            this.errorAddFinanceEmail = false
            this.errorFinanceEmail = []
            this.addFinanceEmail = ""
        },
        submitChangeFinance() {
            if (!this.isValidFinanceEmail()) {
                return false
            }
            let sentEmailData = [...this.financeEmail]
            
            // Check If add email exist in finance email
            // If it is, push to sentEmailData
            if (this.addFinanceEmail && this.financeEmail.length > 0 && this.financeEmail.indexOf(this.addFinanceEmail) == -1) {
                sentEmailData.push(this.addFinanceEmail)
            }
            this.$http.post(process.env.SUBMIT_UPDATE_FINANCE,
                {
                    companyId: this.companyId,
                    financeEmail: sentEmailData
                },
                { headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(res => {
                this.errorAddFinanceEmail = false
                this.errorFinanceEmail = []
                if(res.data.status == 200) {
                    this.financeEmail = ['']
                    this.addFinanceEmail = ''
                    this.getData()
                    $("#modalFinance").modal("hide");
                    swal("Success", "Success update Finance Data", "success", {
                        button: "Close",
                    });
                } else {
                    swal("Sorry", res.data.message, "error", {
                        button: "Close",
                    })
                }
            })
            .catch(err => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                    this.handleLogout()
                    }
                })
            })
            
        },
        toLesseePage(){
            this.$router.push({path:'/partnership/lessee', query: {
                    companyName: '',
                    statusLessee: JSON.stringify([]),
                    salesStatus: JSON.stringify([]),
                    picLessee: JSON.stringify([]),
                    joinLesseeFrom: '',
                    joinLesseeTo: '',
                    page:1
                }
            })
        },
        connectLogRemarks(){
            this.$http.get(process.env.LOG_URL+"/lessee_note/"+this.companyId,{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status === 200) {
                    this.dataRemarks = response.data.content
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        submitRemarks(){
            this.loadingButtonProcess = true
            if (this.remarksNote == '' || this.remarksNote == null) {
                swal("Sorry", "Note must be fill" , "error", {
                  button: "Close",
                })
            }else{
                var note = this.remarksNote

                this.$http.post(process.env.LOG_URL+"/lessee_note/"+this.companyId,{
                    codeLogs: 60,
                    params: [note.replace(this.spaceRegex, ' ')],
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    this.connectLogRemarks()
                })
                .catch(error => {
                    console.log(error)
                })
                this.remarksNote = ''  
            }
            this.loadingButtonProcess = false
        },
        openModalOne(name){
            $("#modal"+name).modal('show')
        },
        editMeetingData(){
            this.editMeeting = true
        },
        cekAttendError: function(x){
            let error = 0
            if (x=='Asani') {
                for (var i = 0; i < this.inputAsaniAttend.length; i++) {
                    if(this.employeeName[i] == '' || this.employeePosition[i] == ''){
                        error = error+1
                    }
                }
            }else{
                for (var i = 0; i < this.inputClientAttend.length; i++) {
                    if(this.clientName[i] == '' || this.clientPosition[i] == ''){
                        error = error+1
                    }
                }
            }
            return error
        },
        addAttend(x){
            let error = 0
            if (x=='Asani') {
                if (this.cekAttendError('Asani') > 0) {
                    swal("Sorry", "Please fill the Asani Attendant" , "error", {
                      button: "Close",
                    })
                }else{
                    this.inputAsaniAttend.push([''])
                    this.employeeName.push('')
                    this.employeePosition.push('')  
                }
            }else{
                if (this.cekAttendError('Client') > 0) {
                    swal("Sorry", "Please fill the Client Attendant" , "error", {
                      button: "Close",
                    })
                }else{
                    this.inputClientAttend.push([''])
                    this.clientName.push('')
                    this.clientPosition.push('')
                }
            }

        },
        removeRow(name,index) {
            if (name=='Asani') {
                this.inputAsaniAttend.splice(index,1)
                this.employeeName.splice(index,1)
                this.employeePosition.splice(index,1)
            }else{
                this.inputClientAttend.splice(index,1)
                this.clientName.splice(index,1)
                this.clientPosition.splice(index,1)
            }
        },
        dateToString: function(date,second){
            var today = new Date(date);

            var month = today.getMonth()+1
            if (month < 10) {
                month = '0'+month
            }
            var dateDay = today.getDate()
            if (dateDay < 10) {
                dateDay = '0'+dateDay
            }
            var hours = today.getHours()
            if (hours < 10) {
                hours = '0'+hours
            }
            var minutes = today.getMinutes()
            if (minutes < 10) {
                minutes = '0'+minutes
            }
            var second = today.getSeconds()
            if (second < 10) {
                second = '0'+second
            }
            var date = today.getFullYear()+'-'+month+'-'+dateDay;
            if (second) {
                var time = hours + ":" + minutes+":"+second;    
            }else{
                var time = hours + ":" + minutes;
            }
            
            var dateTime = date+'T'+time;

            return dateTime
        },
        updateDocStatus(x){
            if (x == 'KTP') {
                if (this.KTPNumber == '' && this.docStatus != 2) {
                    swal("Sorry", "Please fill the KTP Number" , "error", {
                      button: "Close",
                    })
                }else if (this.KTPNumber.length != 16 && this.docStatus != 2) {
                    swal("Sorry", "KTP Number must be 16 Digit" , "error", {
                      button: "Close",
                    })
                }else if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        this.loadingButtonProcess = true
                        this.loadingStatusKTP = true
                        this.submitDocStatus(x)
                    }
                }else{
                    this.loadingButtonProcess = true
                    this.loadingStatusKTP = true
                    this.submitDocStatus(x)  
                }
            }else if (x == 'Akta') {
                if (this.aktaAdressInput == '' && this.docStatus != 2) {
                    swal("Sorry", "Please fill akta address" , "error", {
                      button: "Close",
                    })
                }else if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        this.loadingButtonProcess = true
                        this.loadingStatusAkta = true
                        this.submitDocStatus(x)
                    }
                }else{
                    this.loadingButtonProcess = true
                    this.loadingStatusAkta = true
                    this.submitDocStatus(x)  
                }
            }else if (x == 'SIUP') {
                if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        if (x == 'NPWP/SKT') {
                            this.loadingStatusNPWP = true   
                        }else if (x == 'Akta') {
                            this.loadingStatusAkta = true
                        }else if (x == 'SIUP') {
                            this.loadingStatusSiup = true
                        }else if (x == 'Purchase Order') {
                            this.loadingStatusPurchase = true
                        }
                        this.loadingButtonProcess = true
                        this.submitDocStatus(x) 
                    }
                }else{
                    if (x == 'NPWP/SKT') {
                        this.loadingStatusNPWP = true   
                    }else if (x == 'Akta') {
                        this.loadingStatusAkta = true
                    }else if (x == 'SIUP') {
                        this.loadingStatusSiup = true
                    }else if (x == 'Purchase Order') {
                        this.loadingStatusPurchase = true
                    }
                    this.loadingButtonProcess = true
                    this.submitDocStatus(x)   
                }
            }else if (x == 'Purchase Order') {
                if (this.docStatus == 0) {
                    swal("Sorry", "Please choose status" , "error", {
                      button: "Close",
                    })
                }else if(this.docStatus == 2){
                    if (this.rejectReason == '') {
                        swal("Sorry", "Please fill reason" , "error", {
                          button: "Close",
                        })
                    }else{
                        if (x == 'NPWP/SKT') {
                            this.loadingStatusNPWP = true   
                        }else if (x == 'Akta') {
                            this.loadingStatusAkta = true
                        }else if (x == 'SIUP') {
                            this.loadingStatusSiup = true
                        }else if (x == 'Purchase Order') {
                            this.loadingStatusPurchase = true
                        }
                        this.loadingButtonProcess = true
                        this.submitDocStatus(x) 
                    }
                }else{
                    if (x == 'NPWP/SKT') {
                        this.loadingStatusNPWP = true   
                    }else if (x == 'Akta') {
                        this.loadingStatusAkta = true
                    }else if (x == 'SIUP') {
                        this.loadingStatusSiup = true
                    }else if (x == 'Purchase Order') {
                        this.loadingStatusPurchase = true
                    }
                    this.loadingButtonProcess = true
                    this.submitDocStatus(x)   
                }
            }
        },
        submitDocStatus(x){
            const {companyNPWP16, companyNPWP22} = this.lesseeDetailData.detailLessee[0]
            this.$http.post(process.env.UPDATE_COMPANY_DOC_STATUS,{
                  lesseeId: this.picId,
                  type: x === 'KTP'? "KTP/Passport": x,
                  userKTPPassport: this.KTPNumber !== null ? this.KTPNumber.replace(this.spaceRegex, ' ') : this.KTPNumber,
                  newStatus: this.docStatus,
                  adminId: this.adminId,
                  rejectReason: this.rejectReason !== null ? this.rejectReason.replace(this.spaceRegex, ' ') : this.rejectReason,
                  npwpNumber:this.NpwpDocInput !== null ? this.NpwpDocInput.replace(this.spaceRegex, ' ') : this.NpwpDocInput,
                  npwpNumber16: companyNPWP16,
                  npwpNumber22: companyNPWP22,
                  aktaAddress: this.aktaAdressInput !== null ? this.aktaAdressInput.replace(this.spaceRegex, ' ') : this.aktaAdressInput,
                  newCompany : this.newCompany,
                  companyNameNPWP: this.companyNameNPWP !== null ? this.companyNameNPWP.replace(this.spaceRegex, ' ') : this.companyNameNPWP
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
            .then(response => {
                if (response.data.status == 400) {
                    swal("Sorry", response.data.message , "error", {
                        button: "Close",
                    })
                }
                  if (response.data.status == 200) {
                    swal("Success", response.data.message , "success", {
                      button: "Close",
                    })
                  }
                  if (x == 'KTP') {
                    this.loadingStatusKTP = false
                  }else if (x == 'NPWP/SKT') {
                    this.loadingStatusNPWP = false
                  }else if (x == 'SIUP') {
                    this.loadingStatusSiup = false
                  }else if (x == 'Akta') {
                    this.loadingStatusAkta = false
                  }else if (x == 'Purchase Order') {
                    this.loadingStatusPurchase = false
                  }
                  $('#modalDocPending').modal('hide')
                  this.getData()
                  this.loadingButtonProcess = false
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        updateStatus(){
            let reason = ''
            let newReason = ''
            if (this.chooseCompanyStatus == 99 && this.rejectLesseeReason == '') {
                swal("Sorry", 'Reason must be select' , "error", {
                    button: "Close",
                })
            }else if (this.chooseCompanyStatus == 99 && this.rejectLesseeReason == 'Other' && this.newReason == '') {
                swal("Sorry", 'New reason must be fill' , "error", {
                    button: "Close",
                })
            }else if (this.chooseCompanyStatus == 8) {
                this.loadingButton = true
                this.loadingButtonProcess = true
                this.$http.post(process.env.CEK_COMPANY_STATUS,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        if (response.data.data.companyStatus < 7 || response.data.data == null || response.data.data.companyStatus == null) {
                            swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                button: "Ok",
                            })  
                            $('#modalUpdateStatus').modal('hide')
                            this.loadingButtonProcess = false
                        }else{
                            this.$http.post(process.env.UPDATE_COMPANY_STATUS,{
                                companyId: this.companyId,
                                companyStatus: this.chooseCompanyStatus,
                                reason: this.rejectReason !== null ? this.rejectReason.replace(this.spaceRegex, ' ') : this.rejectReason,
                                newCompany: this.newCompany
                            },{
                              headers: {'Asani-Token':localStorage.getItem('jwt')}
                            })
                            .then(response => {
                              if (response.data.status == 200) {
                                swal("Success", response.data.message , "success", {
                                  button: "Ok",
                                })
                              }
                              if (response.data.status == 201) {
                                swal("Sorry", response.data.message , "error", {
                                  button: "Close",
                                })
                              }
                              if (response.data.status == 400) {
                                    swal("Sorry", response.data.message , "error", {
                                        button: "Close",
                                    })
                                }
                              $('#modalUpdateStatus').modal('hide')
                              this.getData()
                              this.loadingButtonProcess = false
                            })
                            .catch(error => {
                                swal("Sorry", error.response.data.message, "error", {
                                    button: "Ok",
                                }).then(v => {
                                    if(error.response.data.status == 401) {
                                        this.handleLogout()
                                    }
                                })
                            })
                        }
                    }
                    this.loadingButton = false
                })
                .catch(error => {
                  console.log(error)
                  swal("Error", error.message, "error")
                })
            }else if (this.chooseCompanyStatus == 99) {
                if (this.rejectLesseeReason == 'Other') {
                    newReason = this.newReason
                    reason = this.newReason+', '+this.rejectNotes
                }else{
                    if (this.rejectNotes != '') {
                        reason = this.rejectLesseeReason+', '+this.rejectNotes
                    }else{
                        reason = this.rejectLesseeReason
                    }
                    
                }
                this.loadingButtonProcess = true
                this.$http.post(process.env.UPDATE_COMPANY_STATUS,{
                    companyId: this.companyId,
                    companyStatus: this.chooseCompanyStatus,
                    reason: reason !== null ? reason.replace(this.spaceRegex, ' ') : reason,
                    newCompany: this.newCompany,
                    newReason:newReason !== null ? newReason.replace(this.spaceRegex, ' ') : newReason
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                  if (response.data.status == 200) {
                    swal("Success", response.data.message , "success", {
                      button: "Ok",
                    })
                  }
                  if (response.data.status == 201) {
                    swal("Sorry", response.data.message , "error", {
                      button: "Close",
                    })
                  }
                  if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Close",
                        })
                    }
                  $('#modalUpdateStatus').modal('hide')
                  this.getData()
                  this.loadingButtonProcess = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        sendAgreement(x){
            this.loadingButtonProcess = true
            this.$http.post(process.env.SEND_COMPANY_AGREEMENT,{
                companyId: this.companyId,
                agreement: x,
                agreementStatus: this.chooseAgreementStatus,
                newCompany:this.newCompany
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
              if (response.data.status == 200) {
                swal("Success", response.data.message , "success", {
                  button: "Ok",
                })
                if (x == 'send') {
                    // this.sendLog(14,'sendAgreement')
                }else{
                    if (this.chooseAgreementStatus == 1) {
                        // this.sendLog(16,'ProcessAgreement')
                    }else{
                        // this.sendLog(14,'ProcessAgreement')    
                    }
                }
              }
              if (response.data.status == 201) {
                swal("Sorry", response.data.message , "error", {
                  button: "Close",
                })
              }
              if (response.data.status == 400) {
                    swal("Sorry", response.data.message , "error", {
                        button: "Close",
                    })
                }
              $('#modalSendAgreement').modal('hide')
              $('#modalProcessAgreement').modal('hide')
              this.getData()
              this.loadingButtonProcess = false
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },

        onFileDocPicked(e,x) {
            const files = e.target.files
            if (x == 'npwp') {
                if (files[0] !== undefined) {
                    this.NPWPFileName = files[0].name
                    if (this.NPWPFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.NPWPUrl = fr.result
                        this.NPWPFile = files[0] // this is an image file that can be sent to server...
                        this.NPWPBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.NPWPFileName = ''
                    this.NPWPFile = ''
                    this.NPWPUrl = ''
                }
            }else if (x == 'akta') {
                if (files[0] !== undefined) {
                    this.aktaFileName = files[0].name
                    if (this.aktaFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.aktaUrl = fr.result
                        this.aktaFile = files[0] // this is an image file that can be sent to server...
                        this.aktaBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.aktaFileName = ''
                    this.aktaFile = ''
                    this.aktaUrl = ''
                }
            } else if (x == 'aktap') {
                if (files[0] !== undefined) {
                    this.aktaPerubahanFileName = files[0].name
                    if (this.aktaPerubahanFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.aktaPerubahanUrl = fr.result
                        this.aktaPerubahanFile = files[0] // this is an image file that can be sent to server...
                        this.aktaPerubahanBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.aktaPerubahanFileName = ''
                    this.aktaPerubahanFile = ''
                    this.aktaPerubahanUrl = ''
                }
            }else if (x == 'siup') {
                if (files[0] !== undefined) {
                    this.SIUPFileName = files[0].name
                    if (this.SIUPFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.SIUPUrl = fr.result
                        this.SIUPFile = files[0] // this is an image file that can be sent to server...
                        this.SIUPBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.SIUPFileName = ''
                    this.SIUPFile = ''
                    this.SIUPUrl = ''
                }
            }else if (x == 'ktp') {
                if (files[0] !== undefined) {
                    this.KTPFileName = files[0].name
                    if (this.KTPFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.KTPUrl = fr.result
                        this.KTPFile = files[0] // this is an image file that can be sent to server...
                        this.KTPBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.KTPFileName = ''
                    this.KTPFile = ''
                    this.KTPUrl = ''
                }
            }else if (x == 'purchase') {
                if (files[0] !== undefined) {
                    this.purchaseFileName = files[0].name
                    if (this.purchaseFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.purchaseOrderUrl = fr.result
                        this.purchaseFile = files[0] // this is an image file that can be sent to server...
                        this.purchaseBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.purchaseFileName = ''
                    this.purchaseFile = ''
                    this.purchaseOrderUrl = ''
                }
            }else if (x == 'sk') {
                if (files[0] !== undefined) {
                    this.SKFileName = files[0].name
                    if (this.SKFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.SKUrl = fr.result
                        this.SKFile = files[0] // this is an image file that can be sent to server...
                        this.SKBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.SKFileName = ''
                    this.SKFile = ''
                    this.SKUrl = ''
                }
            }else if (x == 'skp') {
                if (files[0] !== undefined) {
                    this.SKPerubahanFileName = files[0].name
                    if (this.SKPerubahanFileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.SKPerubahanUrl = fr.result
                        this.SKPerubahanFile = files[0] // this is an image file that can be sent to server...
                        this.SKPerubahanBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.SKPerubahanFileName = ''
                    this.SKPerubahanFile = ''
                    this.SKPerubahanUrl = ''
                }
            }else{
                if (files[0] !== undefined) {
                    this.visitDocumentation[x].fileName = files[0].name
                    if (this.visitDocumentation[x].fileName.lastIndexOf('.') <= 0) {
                        return
                    }
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.visitDocumentation[x].fileUrl = fr.result
                        this.visitDocumentation[x].file = files[0] // this is an image file that can be sent to server...
                        this.visitDocumentation[x].fileBase64 = fr.result.split("base64,")[1]
                    })
                } else {
                    this.visitDocumentation[x].fileName = ''
                    this.visitDocumentation[x].file = ''
                    this.visitDocumentation[x].fileUrl = ''
                    this.visitDocumentation[x].fileBase64 = ''
                }
            }
        },
        submitMeeting(x){
            if (this.lastStatus != null) {
                if (this.lastStatus != 1) {
                    if (this.meetingStatus == '') {
                       swal("Sorry", 'Status must be select.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingAgenda == '') {
                        swal("Sorry", 'Meeting agenda must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.cekAttendError('Asani') > 0) {
                        swal("Sorry", 'Asani Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.cekAttendError('Client') > 0) {
                        swal("Sorry", 'Client Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.companySince == '') {
                        swal("Sorry", 'Company since must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && (this.totalEmployeeClient == '' || this.totalEmployeeClient == 0)) {
                        swal("Sorry", 'Number of employee must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.industryType == '') {
                        swal("Sorry", 'Industry type must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.meetingResult == '') {
                        swal("Sorry", 'Meeting Result must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 1 && this.listToDo == '') {
                        swal("Sorry", 'List to do must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.meetingSchedule == '') {
                        swal("Sorry", 'Schedule must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.meetingPlace == '') {
                        swal("Sorry", 'Place must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.noteMeeting == '') {
                        swal("Sorry", 'Note must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 2 && this.reasonMeeting == '') {
                        swal("Sorry", 'Reason must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingStatus == 99 && this.reasonMeeting == '') {
                        swal("Sorry", 'Reason must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else{
                        let sendEmail = false
                        if (x=='send') {
                            sendEmail = true
                            this.loadingButtonSaveSend = true
                        }else{
                            this.loadingButtonSave = true
                        }
                        
                        let asaniAttend = []
                        let clientAttend = []
                        let detail = {
                            address: this.meetingAddress,
                            agenda: this.meetingAgenda,
                            companySince: this.companySince,
                            numberOfEmployee: this.totalEmployeeClient,
                            industryType:this.industryType,
                            result: this.meetingResult,
                            listToDo: this.listToDo
                        }
                        for (var i = 0; i < this.inputAsaniAttend.length; i++) {
                            asaniAttend.push({
                                name:this.employeeName[i],
                                position:this.employeePosition[i]
                            })
                        }
                        for (var i = 0; i < this.inputClientAttend.length; i++) {
                            clientAttend.push({
                                name:this.clientName[i],
                                position:this.clientPosition[i]
                            })
                        }
                        this.$http.post(process.env.UPDATE_MEETING,{
                            reschedule: this.dateToString(this.meetingSchedule,false),
                            note: this.noteMeeting !== null ? this.noteMeeting.replace(this.spaceRegex, ' ') : this.noteMeeting,
                            place: this.meetingPlace !== null ? this.meetingPlace.replace(this.spaceRegex, ' ') : this.meetingPlace,
                            lastStatus: parseInt(this.lastStatus),
                            newStatus: this.meetingStatus,
                            reason: this.reasonMeeting !== null ? this.reasonMeeting.replace(this.spaceRegex, ' ') : this.reasonMeeting,
                            companyId: this.companyId,
                            newCompany: this.newCompany,
                            asaniAttend: asaniAttend,
                            clientAttend: clientAttend,
                            detail: detail,
                            sendEmail:sendEmail,
                            visitDocumentation: this.visitDocumentation
                        },{
                            headers: {'Asani-Token':localStorage.getItem('jwt')}
                        })
                        .then(response => {
                            if (response.data.status === 200) {
                                swal("Success", response.data.message , "success", {
                                    button: "Ok",
                                })
                                this.meetingStatus = ''
                                this.meetingSchedule = ''
                                this.meetingPlace = ''
                                this.noteMeeting = ''
                                this.reasonMeeting = ''
                                this.loadingButtonSave = false
                                this.loadingButtonSaveSend = false
                                this.getData()
                            }else if (response.data.status == 400) {
                                swal("Sorry", response.data.message , "error", {
                                    button: "Ok",
                                })
                            }                
                            this.loadingButtonSave = false
                            $('#modalMeeting').modal('hide')
                        })
                        .catch(error => {
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                    this.handleLogout()
                                }
                            })
                        })
                    }
                }else{
                    if (this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingAgenda == '') {
                        swal("Sorry", 'Meeting agenda must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingAddress == '') {
                        swal("Sorry", 'Meeting address must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.cekAttendError('Asani') > 0) {
                        swal("Sorry", 'Asani Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.cekAttendError('Client') > 0) {
                        swal("Sorry", 'Client Attendant must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.companySince == '') {
                        swal("Sorry", 'Company since must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.totalEmployeeClient == '' || this.totalEmployeeClient == 0) {
                        swal("Sorry", 'Number of employee must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.industryType == '') {
                        swal("Sorry", 'Industry type must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.meetingResult == '') {
                        swal("Sorry", 'Meeting Result must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else if (this.listToDo == '') {
                        swal("Sorry", 'List to do must be fill.' , "error", {
                          button: "Close",
                        }) 
                    }else{
                        let sendEmail = false
                        if (x=='send') {
                            sendEmail = true
                            this.loadingButtonSaveSend = true
                        }else{
                            this.loadingButtonSave = true
                        }
                        
                        let asaniAttend = []
                        let clientAttend = []
                        let detail = {
                            address: this.meetingAddress,
                            agenda: this.meetingAgenda,
                            companySince: this.companySince,
                            numberOfEmployee: this.totalEmployeeClient,
                            industryType:this.industryType,
                            result: this.meetingResult,
                            listToDo: this.listToDo
                        }
                        for (var i = 0; i < this.inputAsaniAttend.length; i++) {
                            asaniAttend.push({
                                name:this.employeeName[i],
                                position:this.employeePosition[i]
                            })
                        }
                        for (var i = 0; i < this.inputClientAttend.length; i++) {
                            clientAttend.push({
                                name:this.clientName[i],
                                position:this.clientPosition[i]
                            })
                        }
                        this.$http.post(process.env.UPDATE_MEETING,{
                            reschedule: this.dateToString(this.meetingSchedule,false),
                            note: this.noteMeeting !== null ? this.noteMeeting.replace(this.spaceRegex, ' ') : this.noteMeeting,
                            place: this.meetingPlace !== null ? this.meetingPlace.replace(this.spaceRegex, ' ') : this.meetingPlace,
                            lastStatus: parseInt(this.lastStatus),
                            newStatus: this.meetingStatus,
                            reason: this.reasonMeeting !== null ? this.reasonMeeting.replace(this.spaceRegex, ' ') : this.reasonMeeting,
                            companyId: this.companyId,
                            newCompany: this.newCompany,
                            asaniAttend: asaniAttend,
                            clientAttend: clientAttend,
                            detail: detail,
                            sendEmail:sendEmail,
                            visitDocumentation: this.visitDocumentation
                        },{
                            headers: {'Asani-Token':localStorage.getItem('jwt')}
                        })
                        .then(response => {
                            if (response.data.status === 200) {
                                swal("Success", response.data.message , "success", {
                                    button: "Ok",
                                })
                                this.meetingStatus = ''
                                this.meetingSchedule = ''
                                this.meetingPlace = ''
                                this.noteMeeting = ''
                                this.reasonMeeting = ''
                                this.loadingButtonSave = false
                                this.loadingButtonSaveSend = false
                                this.getData()
                            }else if (response.data.status == 400) {
                                swal("Sorry", response.data.message , "error", {
                                    button: "Ok",
                                })
                            }                
                            this.loadingButtonSave = false
                            $('#modalMeeting').modal('hide')
                        })
                        .catch(error => {
                            swal("Sorry", error.response.data.message, "error", {
                                button: "Ok",
                            }).then(v => {
                                if(error.response.data.status == 401) {
                                this.handleLogout()
                                }
                            })
                        })
                    }
                }
            }else{
                if (this.meetingSchedule == '') {
                    swal("Sorry", 'Schedule must be select.' , "error", {
                      button: "Close",
                    })
                }else if (this.meetingPlace == '') {
                    swal("Sorry", "Place must be fill" , "error", {
                    button: "Ok",
                })
                }else if (this.noteMeeting == '') {
                    swal("Sorry", "Note must be fill" , "error", {
                        button: "Ok",
                    })
                }else{
                    this.loadingButtonSave = true
                    this.$http.post(process.env.UPDATE_MEETING,{
                        schedule: this.dateToString(this.meetingSchedule,false),
                        note: this.noteMeeting !== null ? this.noteMeeting.replace(this.spaceRegex, ' ') : this.noteMeeting,
                        place: this.meetingPlace !== null ? this.meetingPlace.replace(this.spaceRegex, ' ') : this.meetingPlace,
                        lastStatus: parseInt(this.lastStatus),
                        companyId: this.companyId,
                        newCompany: this.newCompany,
                        sendEmail:false
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                        if (response.data.status === 200) {
                            swal("Success", response.data.message , "success", {
                                button: "Ok",
                            })
                            this.meetingSchedule = ''
                            this.meetingPlace = ''
                            this.noteMeeting = ''
                            this.reasonMeeting = ''
                            this.loadingButtonSave = false
                            if (this.companyId != response.data.data.companyId) {
                                this.$router.push({path:'/partnership/lessee/detail/' + response.data.data.companyId, query: {
                                    companyStatus: 'old',
                                }
                              })
                            }
                            this.getData()
                        }else if (response.data.status == 400) {
                            swal("Sorry", response.data.message , "error", {
                                button: "Ok",
                            })
                        }                
                        this.loadingButtonSave = false
                        $('#modalMeeting').modal('hide')
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                }
            }
        },
        submitContacting(){
            if (this.channel == '') {
                swal("Sorry", "Channel must be choose" , "error", {
                    button: "Ok",
                })
            }else if (this.contactingDate == '') {
                swal("Sorry", "Date must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.noteContacting == '') {
                swal("Sorry", "Notes must be fill" , "error", {
                    button: "Ok",
                })
            }else{
                this.loadingButtonSave = true
                this.$http.post(process.env.INSERT_CONTACTING,{
                    channel: this.channel !== null ? this.channel.replace(this.spaceRegex, ' ') : this.channel,
                    date: this.dateToString(this.contactingDate,false),
                    note: this.noteContacting !== null ? this.noteContacting.replace(this.spaceRegex, ' ') : this.noteContacting,
                    companyId: this.companyId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.channel = ''
                        this.noteContacting = ''
                        this.contactingSchedule = ''
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalContacting').modal('hide')
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        submitChangePicAsani(){
            if (this.employeeAsani['id'] == '') {
                swal("Sorry", "PIC must be choose" , "error", {
                    button: "Ok",
                })
            } else if (this.employeeAsani['id'] == this.oldPicAsani) {
                swal("Sorry", "PIC must be different" , "error", {
                    button: "Ok",
                })
            } else{
                this.loadingButtonSave = true
                this.$http.post(process.env.EDIT_ASANI_PIC_COMPANY,{
                    id: this.employeeAsani['id'],
                    companyId: this.companyId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.employeeAsani = {
                            id : '',
                            employeeName:''
                        }
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalEditAsaniPIC').modal('hide')
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        submitChangeSalesStatus(){
            // console.log(this.chooseSalesStatus['status'])
            if (this.chooseSalesStatus['status'].toString() == '') {
                // console.log('ini')
                swal("Sorry", "Status must be choose" , "error", {
                    button: "Ok",
                })
            }else{
                this.loadingButtonSave = true
                this.$http.post(process.env.EDIT_SALES_STATUS,{
                    status: this.chooseSalesStatus['status'],
                    companyId: this.companyId,
                    newCompany: this.newCompany
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.chooseSalesStatus = {
                            status : '',
                            statusName:''
                        }
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalEditSalesStatus').modal('hide')
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }
        },
        sendLog(w,x,y){
            var today = new Date();
            var month = today.getMonth()+1
            if (month < 10) {
                month = '0'+month
            }
            var dateDay = today.getDate()
            if (dateDay < 10) {
                dateDay = '0'+dateDay
            }
            var hours = today.getHours()
            if (hours < 10) {
                hours = '0'+hours
            }
            var minutes = today.getMinutes()
            if (minutes < 10) {
                minutes = '0'+minutes
            }
            var second = today.getSeconds()
            if (second < 10) {
                second = '0'+second
            }
            var date = today.getFullYear()+'-'+month+'-'+dateDay;
            var time = hours + ":" + minutes + ":" + second;
            var dateTime = date+' '+time;
            var admin = this.admin
            var command = 'add-logs'
            // var productName = this.productNameChoose
            
            this.$http.post(process.env.LOG_URL+"/"+y+"/"+x,{
                codeLogs: w,
                params: [],
            },{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                // this.connectLogLessee()
                this.connectLogCompany()
            })
            .catch(error => {
                console.log(error)
            })
        },
        // connectLogLessee:function(){
        //     var lesseeId = this.picId
        //     this.$http.get(process.env.LOG_URL+"/lessee/"+lesseeId,{
        //         headers: {'Asani-Token':localStorage.getItem('jwt')}
        //     })
        //     .then(response => {
        //         if (response.data.status === 200) {
        //             this.dataLog = response.data.content
        //         }
        //     })
        //     .catch(error => {
        //         console.log(error)
        //     })
        // },
        getLogLessee(data){
            this.logLessee = data
        },
        connectLogCompany:function(){
            var companyId = this.companyId
            this.$http.get(process.env.LOG_URL+"/company/"+companyId,{
                headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status === 200) {
                    this.dataLog = response.data.content
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getLogCompany(data){
            this.logCompany = data
        },
        getKabkot(x){
            this.$http.post(process.env.API_GET_KABKOT, {
                provinceId: this.editProvince.provinceId,
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.kabkot = response.data.content
                    if (x == 'ada') {
                        this.editKabKot = ''
                        this.editKecamatan = ''
                    }
                }
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        getKecamatan(x) {
            this.$http.post(process.env.API_GET_KECAMATAN, {
                kabKotId: this.editKabKot.kabKotId,
            },{
              headers: {'Asani-Token':localStorage.getItem('jwt')}
            })
            .then(response => {
                if (response.data.status == 200) {
                    this.kecamatan = response.data.content
                    if (x == 'ada') {
                        this.editKecamatan = ''
                    }
                }
            })
            .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
            })
        },
        pickFile() {
            this.$refs.doc.click()
        },
        onFilePicked(e, types) {
            const files = e.target.files
            if (files[0] !== undefined) {
                if (files[0].size > 10 * 1024 * 1024) {
                    swal("Sorry", 'File size must be less than 10 MB' , "error", {
                        button: "Ok",
                    })
                    this.$refs[types].value = null;
                    return;
                }
                this.docFileName = files[0].name
                if (this.docFileName.lastIndexOf('.') <= 0) {
                    return
                }
                const fr = new FileReader()
                fr.readAsDataURL(files[0])
                fr.addEventListener('load', () => {
                    if(types == 'Akta Perubahan') {
                        this.inputAktaPerubahan = this.docFileName
                    } else if(types == 'SK Menkumham Perubahan') {
                        this.inputSKPerubahan = this.docFileName
                    }
                    if (types === "KTP") {
                        types = "KTP/Passport"
                    }
                    this.docUrl = fr.result
                    this.docFile = files[0] // this is an image file that can be sent to server...
                    this.docBase64 = fr.result.split("base64,")[1]
                    this.attachment.push({ type: types, docFileName: this.docFileName, docBase64: this.docBase64 })
                    if (this.docFileName.toLowerCase().includes(".png") || this.docFileName.toLowerCase().includes(".jpeg") || this.docFileName.toLowerCase().includes(".jpg")) {
                        // this.PurchaseView = true
                    } 
                    // else this.PurchaseView = false
                    // if (this.docFile.size >= 2000000) {
                    //     this.docFileName = ''
                    //     this.docFile = ''
                    //     this.docUrl = ''
                    //     swal("Ukuran file tidak boleh lebih dari 2MB", "", "warning", {
                    //             buttons: {
                    //                 agree: "OK",
                    //             },
                    //         })
                    //         .then((value) => {
                    //             this.pickFile()
                    //         });
                    // }
                })
            } else {
                this.docFileName = ''
                this.docFile = ''
                this.docUrl = ''
            }
        },
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        submitDoc(){
            if (this.docFileName == '') {
                swal("Sorry", "File must be choose" , "error", {
                    button: "Ok",
                })
            } else if (this.docPilih == 'Akta' && this.aktaAdressInput == '') {
                swal("Sorry", "Akta address must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.docPilih == 'KTP' && this.KTPNumber == '') {
                swal("Sorry", "KTP number must be fill" , "error", {
                    button: "Ok",
                })
            }else if (this.docPilih == 'KTP' && this.citizenship === 'wni' && this.KTPNumber.length != 16) {
                swal("Sorry", "KTP number must be 16 digit" , "error", {
                    button: "Ok",
                })
            }else{
                let self = this
                const {companyNPWP16, companyNPWP22, companyNPWP} = this.lesseeDetailData.detailLessee[0]
                this.loadingButtonSave = true
                this.$http.post(process.env.UPDATE_DOC_LESSEE,{
                    docId: this.docId,
                    note: this.noteChangeDocument !== null ? this.noteChangeDocument.replace(this.spaceRegex, ' ') : this.noteChangeDocument,
                    adminId: this.adminId,
                    newCompany: this.newCompany,
                    companyNameNPWP: this.companyNameNPWP !== null ? this.companyNameNPWP.replace(this.spaceRegex, ' ') : this.companyNameNPWP,
                    npwpNumber: companyNPWP,
                    npwpNumber16: companyNPWP16,
                    npwpNumber22: companyNPWP22,
                    aktaAddress: this.aktaAdressInput !== null ? this.aktaAdressInput.replace(this.spaceRegex, ' ') : this.aktaAdressInput,
                    ktpPassportNumber: this.KTPNumber !== null ? this.KTPNumber.replace(this.spaceRegex, ' ') : this.KTPNumber,
                    dataDocument: this.attachment
                },{
                    timeout: 180 * 1000,
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        if (this.docPilih == 'KTP') {
                            this.sendLog(12,this.companyId,'company')
                        }else if (this.docPilih == 'Akta') {
                            this.sendLog(10,this.companyId,'company')
                        }else if (this.docPilih == 'SIUP') {
                            this.sendLog(11,this.companyId,'company')
                        }else if (this.docPilih == 'SK Menkumham') {
                            this.sendLog(106,this.companyId,'company')
                        }
                        this.noteChangeDocument = ''
                        this.docFileName = ''
                        this.docFile = ''
                        this.docUrl = ''
                        this.loadingButtonSave = false
                        this.attachment = []
                        this.getData()
                        if(this.docPilih !== 'Akta' && this.docPilih !== 'SK Menkumham') {
                            document.getElementById("change_document").value = null;
                        }

                        if(this.docPilih == 'Akta' || this.docPilih == 'SK Menkumham') {
                            document.getElementById("change_document_pendirian").value = null;
                            if(this.skmType == 2) {
                                document.getElementById("change_document_perubahan").value = null;
                            }
                        }
                        
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                        // this.loadingButtonSave = false
                        // this.docFileName = ''
                        // this.docBase64 = ''
                        // this.attachment = []
                        // this.handleLogout()
                    }else{
                        swal("Upload Failed", "Something went wrong...", "error", {
                              button: "Ok",
                        })
                    }               
                    this.loadingButtonSave = false
                    this.docFileName = ''
                    this.docBase64 = ''
                    this.attachment = []
                    $('#modalChangeDocument').modal('hide')
                    if(this.docPilih !== 'Akta' && this.docPilih !== 'SK Menkumham') {
                        document.getElementById("change_document").value = null;
                    }

                    if(this.docPilih == 'Akta' || this.docPilih == 'SK Menkumham') {
                        document.getElementById("change_document_pendirian").value = null;
                        if(this.skmType == 2) {
                            document.getElementById("change_document_perubahan").value = null;
                        }
                    }
                })
                .catch(error => {
                    if (error.response) {
                        self.loadingButtonSave = false
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    } else {        
                        if (!error.status) {
                            this.attachment = []
                            self.loadingButtonSave = false
                            self.docFileName = ''
                            self.docBase64 = ''
                            $('#modalChangeDocument').modal('hide')
                            if(self.docPilih !== 'Akta' && self.docPilih !== 'SK Menkumham') {
                                document.getElementById("change_document").value = null;
                            }

                            if(self.docPilih == 'Akta' || self.docPilih == 'SK Menkumham') {
                                document.getElementById("change_document_pendirian").value = null;
                                if(self.skmType == 2) {
                                    document.getElementById("change_document_perubahan").value = null;
                                }
                            }
                            swal("Upload Failed", "Please check your connection", "error", {
                                button: "Ok",
                            })
                        } else {
                            self.loadingButtonSave = false
                            self.docFileName = ''
                            self.docBase64 = ''
                            self.attachment = []
                            if(self.docPilih !== 'Akta' && self.docPilih !== 'SK Menkumham') {
                                document.getElementById("change_document").value = null;
                            }

                            if(self.docPilih == 'Akta' || self.docPilih == 'SK Menkumham') {
                                document.getElementById("change_document_pendirian").value = null;
                                if(self.skmType == 2) {
                                    document.getElementById("change_document_perubahan").value = null;
                                }
                            }
                            swal("Upload Failed", error.message, "error", {
                                button: "Ok",
                            })
                        }
                    }
                })
            }
        },
        submitEditPic(){
            this.loadingButtonSave = true
            if (this.choosePic['lesseeId'] == '') {
                swal("Sorry", "PIC must be choose" , "error", {
                    button: "Ok",
                })
            } else if (this.choosePic["lesseeId"] == this.oldPic) {
                    swal("Sorry", "PIC must be different", "error", {
                        button: "Ok",
                    });
            } else{
                this.loadingButtonSave = true
                this.$http.post(process.env.EDIT_PIC,{
                    id: this.choosePic['lesseeId'],
                    companyId: this.companyId
                },{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status === 200) {
                        swal("Success", response.data.message , "success", {
                            button: "Ok",
                        })
                        this.choosePic = {
                            id : '',
                            lesseeName:''
                        }
                        this.loadingButtonSave = false
                        this.getData()
                    }else if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }                
                    this.loadingButtonSave = false
                    $('#modalEditPIC').modal('hide')
                })
                .catch(error => {
                    this.loadingButtonSave = false
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }

        },
        toDetail(id, orderCode, companyId){
            this.$router.push({path:'/order/detail/' + id, query: {
                orderCode: orderCode,
                companyIdDetail: companyId
              }
            })
        },
        ValidateFileUpload() {
            var fuData = document.getElementById('file_foto_rent');
            var FileUploadPath = fuData.value;

            if (FileUploadPath == '') {
                alert("Please upload an image");
            } else {
                var Extension = FileUploadPath.substring(
                FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
                if (Extension =="png" || Extension =="jpg") {
                    if (fuData.files && fuData.files[0]) {
                        var reader = new FileReader();
                        reader.onload = function(e) {
                            $('#show_img_rent').attr('src', e.target.result);
                        }
                        reader.readAsDataURL(fuData.files[0]);
                    }
                }else {
                    alert("Photo only allows file types of PNG.");
                    document.getElementById("file_foto_rent").value ="";
                      // document.getElementById("show_img_"+index).src = './images/no-image-icon-23485.png';
              }
            }
        },
        cekAsaniPic(){
            if (this.asaniEmployeeName == '' || this.asaniEmployeeName == null) {
                swal("Sorry", "Select PIC Asani before continue the process." , "error",{
                    button: "Ok",
                })
                this.getData()
            }else{
                this.openModal('Contacting')
            }
        },
        openModal(x,y,z) {
            this.docPilih = y
            let error = 0
            if (x == 'Contacting') {
                this.channel = ''
                this.noteContacting = ''
                this.contactingDate = ''
                this.loadingTable = true
                this.$http.post(process.env.GET_CONTACTING,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }
                  this.dataContacting = response.data.content
                  this.loadingTable = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            } else if(x == 'EditFinance') {
                $("#modal"+x).modal('show')
            }
            else if (x == 'DocPending') {
                this.docStatus = z
                this.docId = this.companyId
                this.loadingTableDoc = true
                this.$http.post(process.env.GET_HISTORY_DOC,{
                  docType: this.docPilih,
                  docId: this.docId,
                  newUser: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }
                  this.historyDocData = response.data.content
                  this.loadingTableDoc = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }else if(x == 'ChangeDocument'){
                this.docId = this.companyId
            }else if(x == 'EditCompany'){
                this.editProvince = this.apiProvince
                if (this.editProvince != '') {
                    this.getKabkot()                    
                }
                this.editKabKot = this.apiKabKot
                this.kabkot = this.apiDataKabkot
                if (this.editKabKot != '') {
                    this.getKecamatan()
                }
                this.editKecamatan = this.apiKecamatan
                this.kecamatan = this.apiDataKecamatan
                this.editCompanyNpwp = this.companyNPWP
            }else if (x == 'Meeting') {
                if (this.lastStatus == 1) {
                    this.meetingAddress = this.editMeetingAddress
                    this.meetingAgenda = this.editMeetingAgenda
                    this.inputAsaniAttend = []
                    this.inputClientAttend = []
                    this.employeeName=[]
                    this.employeePosition=[]
                    this.clientName =[]
                    this.clientPosition=[]
                    for (var i = 0; i < this.editInputAsaniAttend.length; i++) {
                            this.inputAsaniAttend.push([''])
                            this.employeeName.push(this.editEmployeeName[i])
                            this.employeePosition.push(this.editEmployeePosition[i])
                    }
                    for (var i = 0; i < this.editInputClientAttend.length; i++) {
                            this.inputClientAttend.push([''])
                            this.clientName.push(this.editClientName[i])
                            this.clientPosition.push(this.editClientPosition[i])
                    }
                    this.meetingResult = this.editMeetingResult
                    this.listToDo = this.editListToDo
                }
                this.editMeeting = false
                this.loadingButton = true
                this.$http.post(process.env.CEK_COMPANY_STATUS,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        if (response.data.data.companyStatus < 1 || response.data.data == null || response.data.data.companyStatus == null) {
                            swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                button: "Ok",
                            })  
                        }else{
                            $("#modal"+x).modal('show')
                        }
                    }
                    this.loadingButton = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }else if (x == 'UploadLegalDocument') {
                this.loadingButton = true
                this.$http.post(process.env.CEK_COMPANY_STATUS,{
                  companyId: this.companyId,
                  newCompany: this.newCompany
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 400) {
                        swal("Sorry", response.data.message , "error", {
                            button: "Ok",
                        })
                    }else{
                        if (response.data.data.companyStatus < 3 || response.data.data == null || response.data.data.companyStatus == null) {
                            swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                button: "Ok",
                            })  
                        }else{
                            if (this.companyStatus <= 4) {
                                $("#modal"+x).modal('show')
                            } 
                        }
                    }
                    this.loadingButton = false
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
            }else if (x == 'SendAgreement') {
                if (this.companyStatus != 99) {
                    this.loadingButton = true
                    this.$http.post(process.env.CEK_COMPANY_STATUS,{
                      companyId: this.companyId,
                      newCompany: this.newCompany
                    },{
                      headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message , "error", {
                                button: "Ok",
                            })
                        }else{
                            if (response.data.data.companyStatus < 5 || response.data.data == null || response.data.data.companyStatus == null) {
                                swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                    button: "Ok",
                                })  
                            }else{
                                $("#modal"+x).modal('show')
                            }
                        }
                        this.loadingButton = false
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                }
            }else if (x == 'ProcessAgreement') {
                if (this.companyStatus != 99) {
                    this.loadingButton = true
                    this.$http.post(process.env.CEK_COMPANY_STATUS,{
                      companyId: this.companyId,
                      newCompany: this.newCompany
                    },{
                      headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                        if (response.data.status == 400) {
                            swal("Sorry", response.data.message , "error", {
                                button: "Ok",
                            })
                        }else{
                            if (response.data.data.companyStatus < 6 || response.data.data == null || response.data.data.companyStatus == null) {
                                swal("Sorry", 'You must follow step KYC lessee' , "error", {
                                    button: "Ok",
                                })  
                            }else if (response.data.content >= 7) {
                                 
                            }else{
                                $("#modal"+x).modal('show')
                            }
                        }
                        this.loadingButton = false
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                }
            }else if (x == 'UpdateStatus') {
                // this.loadingButton = true
                // this.$http.post(process.env.CEK_COMPANY_STATUS,{
                //   companyId: this.companyId,
                //   newCompany: this.newCompany
                // },{
                //   headers: {'Asani-Token':localStorage.getItem('jwt')}
                // })
                // .then(response => {
                //     if (response.data.status == 400) {
                //         swal("Sorry", response.data.message , "error", {
                //             button: "Ok",
                //         })
                //         this.handleLogout()
                //     }else{
                //         if (response.data.content < 5 || response.data.content == null) {
                //             swal("Sorry", 'You must follow step KYC lessee' , "error", {
                //                 button: "Ok",
                //             })  
                //         }else{
                //             $("#modal"+x).modal('show')
                //         }
                //     }
                //     this.loadingButton = false
                // })
                // .catch(error => {
                //   console.log(error)
                // })
                this.rejectLesseeReason=''
                this.rejectNotes=''
                this.newReason=''
                this.chooseCompanyStatus=8
                $("#modal"+x).modal('show')
            }
            if (x != 'UploadLegalDocument' && x != 'SendAgreement' && x != 'ProcessAgreement' && x != 'UpdateStatus' && x != 'Meeting'){
                $("#modal"+x).modal('show')
            }
        },
        viewAll(x){
            this.$router.push('/order/search')
            localStorage.setItem('companyName', x)
            localStorage.setItem('orderId',"")
            localStorage.setItem('statusOrder',"")
        },
        toPage(e) {
            this.$router.push(e)
        },
        cekLogin(){
            if (localStorage.getItem('jwt') == null) {
                this.$router.push('/')
            }
        },
        async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
            localStorage.removeItem('jwt')
            localStorage.removeItem('admin_name')
            localStorage.removeItem('roles')
            localStorage.removeItem('user_email')
            localStorage.removeItem('admin_id')
            localStorage.removeItem('changeCatalogPermission')
            this.$router.push('/')
        },
        sidebar(){
            $("#wrapper").toggleClass("toggled");
        },
        close() {
            this.$emit('close');
        },
        cekInput(){

        },
        cekPermission(){
          this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
          for(var i=0; i < this.permission.length; i++){
            if( this.permission[i] == "1"){
              this.viewDashboard = true
            }
            if( this.permission[i] == "2.1"){
              this.viewOrder = true
            }
            if( this.permission[i] == "2.2"){
              this.editOrder = true
            }
            if( this.permission[i] == '3.1'){
              this.viewReturn = true
            }
            if( this.permission[i] == '3.2'){
              this.editReturn = true
            }
            if( this.permission[i] == '4.1'){
              this.viewProduct = true
            }
            if( this.permission[i] == '4.2'){
              this.editProduct = true
            }
            if( this.permission[i] == '5.1'){
              this.viewPairing = true
            }
            if( this.permission[i] == '5.2'){
              this.editPairing = true
            }
            if( this.permission[i] == '6'){
              this.viewReconcile = true
            }
            if( this.permission[i] == '7.1'){
              this.viewResolution = true
            }
            if( this.permission[i] == '7.2'){
              this.editResolution = true
            }
            if( this.permission[i] == '8.1'){
              this.viewLessor = true
            }
            if( this.permission[i] == '8.2'){
              this.editLessor = true
            }
            if( this.permission[i] == '9.1'){
              this.viewLessee = true
            }
            if( this.permission[i] == '9.2'){
              this.editLessee = true
            }
            if( this.permission[i] == '10'){
              this.viewEmployee = true
            }
          }
          if (this.viewLesse == false) {
            this.$router.push('/')
          }
        },
        searchData(){
            if (this.assignDeposit == 1) {
                if (this.Deposit != 0) {
                    this.$http.post(process.env.TES,{
                        orderId: this.orderId,
                        Deposit: this.Deposit,
                        productOrder: this.inputs
                    },{
                        headers: {'Asani-Token':localStorage.getItem('jwt')}
                    })
                    .then(response => {
                        this.dataOrder = response.data.content.data
                        this.totalPage = response.data.content.totalPage
                        this.totalData = response.data.content.totalData
                        this.currentPage = response.data.content.currentPage
                        localStorage.setItem('companyName', this.companyName)
                        localStorage.setItem('orderId', this.orderId)
                        localStorage.setItem('statusOrder', this.statusOrder)
                      // this.$router.push('/order/search')
                    })
                    .catch(error => {
                        swal("Sorry", error.response.data.message, "error", {
                            button: "Ok",
                        }).then(v => {
                            if(error.response.data.status == 401) {
                                this.handleLogout()
                            }
                        })
                    })
                }
            }
        },
        getData(){
            this.loadingStatusKTP = true
            this.loadingStatusNPWP = true
            this.loadingStatusSiup = true
            this.loadingStatusAkta = true
            this.loadingStatusSK = true
            this.loadingTable = true
            this.companyId = this.$route.params.companyId
            this.$http.post(process.env.GET_DETAIL_LESSEE,{
                  companyId: this.companyId,
                  companyStatus: this.$route.query.companyStatus
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
              .then(response => {
                this.lesseeDetailData = response.data.data
                this.newCompany = response.data.data.newCompany
                if (!this.newCompany) {
                    this.productRenting = response.data.data.productRenting[0].productRenting
                }
                this.agreementCount = response.data.data.detailLessee[0].agreementCount
                this.agreementStatus = response.data.data.detailLessee[0].agreementStatus
                this.dataPayment = response.data.data.dataPayment
                this.historyOrder = response.data.data.historyOrder
                this.rejectCompanyReason = response.data.data.detailLessee[0].rejectReason
                this.asaniPicPhone = response.data.data.detailLessee[0].employeePhone
                this.asaniEmployeeName = response.data.data.detailLessee[0].employeeName
                if (response.data.data.detailLessee[0].employeeName != null) {
                    this.oldPicAsani = response.data.data.detailLessee[0].idEmployee
                    this.employeeAsani['employeeName'] = response.data.data.detailLessee[0].employeeName
                    this.employeeAsani['id'] = response.data.data.detailLessee[0].idEmployee
                }
                this.salesStatus = response.data.data.detailLessee[0].salesStatus
                if (response.data.data.detailLessee[0].salesStatus != null) {
                    this.chooseSalesStatus['status'] = response.data.data.detailLessee[0].salesStatus
                    this.chooseSalesStatus['statusName'] = response.data.data.detailLessee[0].salesStatusName
                }

                let docs = response.data.data.companyDoc

                docs.forEach(el => {
                    if (el.docType == 'NPWP/SKT') {
                        this.getNPWPName = el.docType
                        this.NPWPUrl = el.url
                        this.NPWPStatus = el.status
                    } else if (el.docType == 'KTP/Passport') {
                        this.getKtpName = el.doctype
                        this.companyKTPUrl = el.url
                        this.companyKTPStatus = el.status
                    } else if (el.docType == 'Akta') {
                        this.getAktaName = el.doctype
                        this.aktaUrl = el.url
                        this.aktaStatus = el.status
                    } else if (el.docType == 'Akta Perubahan') {
                        this.getAktaPerubahanName = el.doctype
                        this.aktaPerubahanUrl = el.url
                        this.aktaPerubahanStatus = el.status
                    } else if (el.docType == 'SIUP') {
                        this.getSiupName = el.doctype
                        this.siupUrl = el.url
                        this.siupStatus = el.status
                    } else if (el.docType == 'SK Menkumham') {
                        this.getSKName = el.doctype
                        this.SKUrl = el.url
                        this.SKStatus = el.status
                    } else if (el.docType == 'SK Menkumham Perubahan') {
                        this.getSKPerubahanName = el.doctype
                        this.SKPerubahanUrl = el.url
                        this.SKPerubahanStatus = el.status
                    }
                })
                
                this.companyName = response.data.data.detailLessee[0].companyName
                this.companyNameNPWP = response.data.data.detailLessee[0].companyNameNPWP
                this.companyStatus = response.data.data.detailLessee[0].companyStatus
                this.companyAddress = response.data.data.detailLessee[0].companyAddress
                this.companyPhone = response.data.data.detailLessee[0].companyPhone
                this.companyFax = response.data.data.detailLessee[0].companyFax
                this.picId = response.data.data.detailLessee[0].userId
                this.userName = response.data.data.detailLessee[0].userName
                let financeData = response.data.data.detailLessee[0].financeEmail
                if(financeData) {
                    // Check wheter financeData is string or object, beacuse sometimes it's string, idk why
                    if (typeof financeData === 'string') {
                        this.financeEmailInfo = JSON.parse(financeData)
                        this.financeEmail = JSON.parse(financeData)
                    } else {
                        this.financeEmailInfo = financeData
                        this.financeEmail = financeData
                    }
                }
                this.oldPic = this.picId
                this.choosePic = {
                    lesseeId: this.picId,
                    lesseeName: this.userName
                }
                this.oldPic = this.picId
                this.companyKtpPassportNumber = response.data.data.detailLessee[0].companyKtpPassportNumber
                this.citizenship = response.data.data.detailLessee[0].citizenship
                this.userPhone = response.data.data.detailLessee[0].userPhone
                this.userEmail = response.data.data.detailLessee[0].userEmail
                this.userPosition = response.data.data.detailLessee[0].userPosition
                this.userDivision = response.data.data.detailLessee[0].userDivision
                this.editUserName = response.data.data.detailLessee[0].userName
                this.editUserKTP = response.data.data.detailLessee[0].companyKTPNumber
                this.editUserPhone = response.data.data.detailLessee[0].userPhone
                this.editUserEmail = response.data.data.detailLessee[0].userEmail
                this.editUserPosition = response.data.data.detailLessee[0].userPosition
                this.editUserDivision = response.data.data.detailLessee[0].userDivision
                this.aktaAddress = response.data.data.detailLessee[0].aktaAddress
                this.source = response.data.data.detailLessee[0].source
                this.companyNPWP = response.data.data.detailLessee[0].companyNPWP
                this.companyNPWP16 = response.data.data.detailLessee[0].companyNPWP16
                this.companyNPWP22 = response.data.data.detailLessee[0].companyNPWP22
                this.companyId = response.data.data.detailLessee[0].companyId
                this.companyLogoUrl = response.data.data.detailLessee[0].companyLogoUrl
                this.editCompanyFax = response.data.data.detailLessee[0].companyFax
                this.editCompanyPhone = response.data.data.detailLessee[0].companyPhone
                this.editSource = response.data.data.detailLessee[0].source
                this.editCompanyAddress = response.data.data.detailLessee[0].companyAddress
                this.editAktaAddress = response.data.data.detailLessee[0].aktaAddress
                this.editCompanyName = response.data.data.detailLessee[0].companyName
                if(response.data.data.detailLessee[0].companyProvince != null){
                    this.apiProvince = {
                        provinceId: response.data.data.province[0].provinceId,
                        provinceName: response.data.data.province[0].provinceName,
                    }
                    // this.getKabkot()
                    this.companyProvince = response.data.data.province[0].provinceName
                }
                this.editKabKot = response.data.data.detailLessee[0].companyKabkot
                if(response.data.data.detailLessee[0].companyKabkot != null){
                    this.apiKabKot = {
                        kabKotId: response.data.data.kabkot[0].kabKotId,
                        kabKotName: response.data.data.kabkot[0].kabKotName,
                    }
                    this.companyCity = response.data.data.kabkot[0].kabKotName
                    // this.getKecamatan()
                }
                this.editKecamatan = response.data.data.detailLessee[0].kecamatanName
                if(response.data.data.detailLessee[0].companyKecamatan != null){
                    this.apiKecamatan = {
                        kecamatanId: response.data.data.kecamatan[0].kecamatanId,
                        kecamatanName: response.data.data.kecamatan[0].kecamatanName,
                    }
                    this.companyDistrict = response.data.data.kecamatan[0].kecamatanName
                }
                this.editKelurahan = response.data.data.detailLessee[0].companyKelurahan
                this.companyVillage = response.data.data.detailLessee[0].companyKelurahan
                this.companyZip = response.data.data.detailLessee[0].companyZip
                this.editZip = response.data.data.detailLessee[0].companyZip
                this.loadingStatusKTP = false
                this.loadingStatusNPWP = false
                this.loadingStatusSiup = false
                this.loadingStatusAkta = false
                this.loadingStatusSK = false
                this.loadingTable =false
                this.docApprove=0
                if (this.NPWPStatus == 1) {
                    this.docApprove++
                }
                if (this.companyKTPStatus == 1) {                 
                    this.docApprove++
                }
                if (this.siupStatus == 1) {
                    this.docApprove++
                }
                if (this.aktaStatus == 1) {
                    this.docApprove++
                }
                if (this.SKStatus == 1) {
                    this.docApprove++
                }
                // this.connectLogLessee()
                this.connectLogCompany()
              })
              .catch(error => {
                swal("Sorry", error.response.data.message, "error", {
                    button: "Ok",
                }).then(v => {
                    if(error.response.data.status == 401) {
                        this.handleLogout()
                    }
                })
              })

              this.$http.post(process.env.GET_LESSEE_ADMIN,{
                companyId: this.$route.params.companyId,
                status: this.$route.query.companyStatus
                // page:1
              },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.lesseeAdmin = response.data.content.allAdmin
                        this.lesseeSelect = response.data.content.activeAdmin
                        this.currentPage = response.data.content.currentPage
                        this.totalData = response.data.content.totalData
                        this.totalPage = response.data.content.totalPage
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })

              this.$http.get(process.env.API_GET_PROVINCE
                ,{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.province = response.data.content
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })

                this.$http.get(process.env.GET_ALL_EMPLOYEE
                ,{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.employeeSelect = response.data.content
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })

                this.$http.get(process.env.GET_LESSEE_SOURCE,{
                    headers: {'Asani-Token':localStorage.getItem('jwt')}
                  })
                  .then(response => {
                    if (response.data.status == 400) {
                          swal("Sorry", response.data.message, "error", {
                                button: "Ok",
                              })
                        }else{
                          this.sourceSelect = response.data.data
                        }
                  })
                  .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                  })

                this.$http.post(process.env.GET_MEETING
                ,{
                  // companyId: this.$route.params.companyId,
                  companyId: this.$route.params.companyId,
                  status: this.$route.query.companyStatus
                },{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.dataMeeting = response.data.content.data
                        this.lastStatus = response.data.content.lastStatus
                        if (this.lastStatus == 1) {
                            let jml = response.data.content.data.length
                            this.editMeetingAddress = JSON.parse(response.data.content.data[jml-1].momResult).address
                            this.meetingAddress = JSON.parse(response.data.content.data[jml-1].momResult).address
                            this.editMeetingAgenda = JSON.parse(response.data.content.data[jml-1].momResult).agenda
                            this.meetingAgenda = JSON.parse(response.data.content.data[jml-1].momResult).agenda
                            this.editCompanySince = JSON.parse(response.data.content.data[jml-1].momResult).companySince
                            this.companySince = JSON.parse(response.data.content.data[jml-1].momResult).companySince
                            this.editTotalEmployeeClient = JSON.parse(response.data.content.data[jml-1].momResult).numberOfEmployee
                            this.totalEmployeeClient = JSON.parse(response.data.content.data[jml-1].momResult).numberOfEmployee
                            this.editIndustryType = JSON.parse(response.data.content.data[jml-1].momResult).industryType
                            this.industryType = JSON.parse(response.data.content.data[jml-1].momResult).industryType
                            this.editMeetingResult = JSON.parse(response.data.content.data[jml-1].momResult).result
                            this.meetingResult = JSON.parse(response.data.content.data[jml-1].momResult).result
                            this.editListToDo = JSON.parse(response.data.content.data[jml-1].momResult).listToDo
                            this.listToDo = JSON.parse(response.data.content.data[jml-1].momResult).listToDo
                            this.editEmployeeName =[]
                            this.employeeName =[]
                            this.editEmployeePosition =[]
                            this.employeePosition =[]
                            this.editInputAsaniAttend =[]
                            this.inputAsaniAttend =[]
                            for (var i = 0; i < JSON.parse(response.data.content.data[jml-1].attendant).asani.length; i++) {
                                this.editInputAsaniAttend.push([''])
                                this.inputAsaniAttend.push([''])
                                this.editEmployeeName.push(JSON.parse(response.data.content.data[jml-1].attendant).asani[i].name)
                                this.employeeName.push(JSON.parse(response.data.content.data[jml-1].attendant).asani[i].name)
                                this.editEmployeePosition.push(JSON.parse(response.data.content.data[jml-1].attendant).asani[i].position)
                                this.employeePosition.push(JSON.parse(response.data.content.data[jml-1].attendant).asani[i].position)
                            }
                            this.editClientName =[]
                            this.clientName =[]
                            this.editClientPosition =[]
                            this.clientPosition =[]
                            this.editInputClientAttend =[]
                            this.inputClientAttend =[]
                            for (var i = 0; i < JSON.parse(response.data.content.data[jml-1].attendant).client.length; i++) {
                                this.editInputClientAttend.push([''])
                                this.inputClientAttend.push([''])
                                this.editClientName.push(JSON.parse(response.data.content.data[jml-1].attendant).client[i].name)
                                this.clientName.push(JSON.parse(response.data.content.data[jml-1].attendant).client[i].name)
                                this.editClientPosition.push(JSON.parse(response.data.content.data[jml-1].attendant).client[i].position)
                                this.clientPosition.push(JSON.parse(response.data.content.data[jml-1].attendant).client[i].position)
                            }

                            for (var i = 0; i < JSON.parse(response.data.content.data[jml-1].urlVisit).length; i++) {
                                this.editVisitDocumentation[i].fileUrl = JSON.parse(response.data.content.data[jml-1].urlVisit)[i]
                                this.visitDocumentation[i].fileUrl = JSON.parse(response.data.content.data[jml-1].urlVisit)[i]
                            }
                        }
                        // JSON.parse(response.data.content.data[0].attendant).asani
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })

                this.$http.get(process.env.GET_LESSEE_REJECT_REASON
                ,{
                  headers: {'Asani-Token':localStorage.getItem('jwt')}
                })
                .then(response => {
                    if (response.data.status == 200) {
                        this.reasonSelect = response.data.content
                    }
                })
                .catch(error => {
                    swal("Sorry", error.response.data.message, "error", {
                        button: "Ok",
                    }).then(v => {
                        if(error.response.data.status == 401) {
                            this.handleLogout()
                        }
                    })
                })
          }
    },
    watch: {
            financeEmail: {
                handler: function(val) {
                    let isEmail = /\S+@\S+\.\S+/;
                    if(this.financeEmail.length == 1) {
                        if(isEmail.test(this.financeEmail[0])) {
                            this.allEmailFilled = true
                        } else {
                            this.allEmailFilled = false
                        }
                    } else if (this.financeEmail.length > 1) {
                        for(let i in this.financeEmail) {
                            if(this.financeEmail[i] == '' || this.financeEmail == null || !isEmail.test(this.financeEmail[i])) {
                                this.allEmailFilled = false
                            } else {
                                this.allEmailFilled = true
                            }
                        }
                    }
                
                }
            },
            addFinanceEmail: {
                handler: function(val) {
                    let isEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;
                    if(this.addFinanceEmail.length > 0) {
                        if(isEmail.test(this.addFinanceEmail)) {
                            this.allEmailFilled = true
                        } else {
                            this.allEmailFilled = false
                        }
                    } else {
                        this.allEmailFilled = true
                    }
                }
            }
        },
    created(){
      this.getData()
      this.admin = localStorage.getItem('admin_name')
      this.adminId = localStorage.getItem('admin_id')
      this.cekLogin()
      this.cekPermission()
      this.connectLogRemarks()
    }
  }
</script>

<!-- Add"scoped" attribute to limit CSS to this component only -->
<style scoped>
.border-red{
  border-color:red;
}
.font-red{
    color: red;
    /*margin-top: -15px;*/
}
.icon-verified {
    max-width: 22px;
    max-height: 22px;
    margin-right: 2px;
}
.edit-status{
    margin-bottom: 0
}
.permonth{ 
  margin: 5px 0px 5px 5px;
}
.text-partnership{
  margin-bottom: 0px;
}

.textarea-kyc{
    resize: none;
}

.img-responsive{
  width: 250px;
  height: auto;
}

.process-vendor-new{
  max-width: 345px;
  margin: 5px 5px;
}

.process-qty-new{
  max-width: 62px;
  margin: 5px 5px;
}

.process-vendor{
  min-width: 345px;
  margin-bottom: 5px;
}

.process-qty{
  max-width: 62px;
}

.button-plus {
    position: absolute;
    bottom: 21px;
    right: 0px;
}

.input-title{
  margin: 0px 5px;
}

.input-one-line{
  display: flex;
}

.input-one-line-assign{
  display: flex;
  width: 100%;
}

.input-title-assign{
  margin: 0px 5px;
  width: 100%;
}

.input-title-qty{
  margin: 0px 5px;
  width: 100%;
}

.title-product{
  width: 100%;
  margin: 5px 0px;
}

.input-group-addon {
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 4px 0px 0px 4px;
    border-right: none;
}

.label-addon-rp{
  margin: 1px 0px;
}

.change-title{
  display: block;
}

.one-line{
  display: flex;
  margin: 5px 0px;
}

.one-line .ol-label-file{
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-titik2-file{
  width: 10px;
  margin: 2px 0px;
}

.one-line .ol-label{
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-reason{
  width: 88px;
  margin: 2px 0px;
}

.one-line .ol-label-price{
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2{
  width: 15px;
  margin: 2px 0px;
}

.one-line .ol-titik2-price{
  margin: 2px 0px;
}

.one-line .ol-value{
  width: 100%;
  margin: 2px 0px;
}

.one-line input [type=file] {
    width: 100%;
}

.fixed_header{
  table-layout: fixed;
  border-collapse: collapse;
}

.fixed_header tbody{
  display:block;
  overflow:auto;
  height:200px;
  width:100%;
}

.fixed_header tbody.full-width tr td{
  width:1578px;
}

.fixed_header thead tr{
  display:block;
}

.fixed_header th, .fixed_header td {
  padding: 5px;
  text-align: left;
  width: 200px;
}

.fixed_header.payment th, .fixed_header.payment td {
  padding: 5px;
  text-align: left;
  width: 217px;
}

.pagination{
  padding: 0px 0;
}

.pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover{
  text-decoration: none;
}
.p8 a.page:hover{
  text-decoration: none;
  color: #fff;
}

.p8 .is-active{
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}
.alignright {
  float: right;
}

.pagg{
  display: inline-flex;
  overflow:auto;
}

.total-data{
  font-size: 14px;
  color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
  float: right;  
}

/*.table td, .table th {
    padding: 0.25rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
    }*/
    .search-table{
      padding-bottom: 7px;
      margin-top: -5px;
      margin-left: -15px;
    }
    .active{
      color: #2797FB;
    }
    .right-dropdown{
      margin-left: 7px;
    }
    .account-div{
      margin: 2px 2px;
    }
    .right-arrow{
      margin-left: auto;
    }
    .brand-logo{
      width: 120px;
    }
    .menu-title{
      margin-left: 1.125rem;
    }
    .menu-title-order{
      margin-left: 1.95rem;
    }
    .menu-title-payment{
      margin-left: 1.525rem;
    }

    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      /*width: 200px;*/
      /*background-color: #f1f1f1;*/
    }

    li.sidebar a {
      display: block;
      color: #000;
      padding: 8px 63px;
      text-decoration: none;
    }

    li a.active {
      background-color: #4CAF50;
      color: white;
    }

    li a:hover:not(.active) {
      background-color: #2797FB;
      color: white;
    }
    .nav-side-menu {
      overflow: auto;
      font-family: verdana;
      font-size: 12px;
      font-weight: 200;
      background-color: #2e353d;
      position: fixed;
      top: 0px;
      width: 300px;
      height: 100%;
      color: #e1ffff;
    }
    .nav-side-menu .brand {
      background-color: #23282e;
      line-height: 50px;
      display: block;
      text-align: center;
      font-size: 14px;
    }
    .nav-side-menu .toggle-btn {
      display: none;
    }
    .nav-side-menu ul,
    .nav-side-menu li {
      list-style: none;
      padding: 0px;
      margin: 0px;
      line-height: 35px;
      cursor: pointer;
    }
    .nav-side-menu ul :not(collapsed) .arrow:before,
    .nav-side-menu li :not(collapsed) .arrow:before {
      font-family: FontAwesome;
      content:"\f078";
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
    .nav-side-menu ul .active,
    .nav-side-menu li .active {
      border-left: 3px solid #d19b3d;
      background-color: #4f5b69;
    }
    .nav-side-menu ul .sub-menu li.active,
    .nav-side-menu li .sub-menu li.active {
      color: #d19b3d;
    }
    .nav-side-menu ul .sub-menu li.active a,
    .nav-side-menu li .sub-menu li.active a {
      color: #d19b3d;
    }
    .nav-side-menu ul .sub-menu li,
    .nav-side-menu li .sub-menu li {
      background-color: #181c20;
      border: none;
      line-height: 28px;
      border-bottom: 1px solid #23282e;
      margin-left: 0px;
    }
    .nav-side-menu ul .sub-menu li:hover,
    .nav-side-menu li .sub-menu li:hover {
      background-color: #020203;
    }
    .nav-side-menu ul .sub-menu li:before,
    .nav-side-menu li .sub-menu li:before {
      font-family: FontAwesome;
      content:"\f105";
      display: inline-block;
      padding-left: 10px;
      padding-right: 10px;
      vertical-align: middle;
    }
    .nav-side-menu li {
      padding-left: 0px;
      border-left: 3px solid #2e353d;
      border-bottom: 1px solid #23282e;
    }
    .nav-side-menu li a {
      text-decoration: none;
      color: #e1ffff;
    }
    .nav-side-menu li a i {
      padding-left: 10px;
      width: 20px;
      padding-right: 20px;
    }
    .nav-side-menu li:hover {
      border-left: 3px solid #d19b3d;
      background-color: #4f5b69;
      -webkit-transition: all 1s ease;
      -moz-transition: all 1s ease;
      -o-transition: all 1s ease;
      -ms-transition: all 1s ease;
      transition: all 1s ease;
    }
    @media (max-width: 767px) {
      .nav-side-menu {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
      }
      .nav-side-menu .toggle-btn {
        display: block;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 10 !important;
        padding: 3px;
        background-color: #ffffff;
        color: #000;
        width: 40px;
        text-align: center;
      }
      .brand {
        text-align: left !important;
        font-size: 22px;
        padding-left: 20px;
        line-height: 50px !important;
      }
    }
    @media (min-width: 767px) {
      .nav-side-menu .menu-list .menu-content {
        display: block;
      }
    }
    @media (max-width: 573px){
      .mobile-div{
        padding: 2px 0px;
      }
    }
  </style>



// WEBPACK FOOTER //
// src/components/Partnership/LesseeDetailPage.vue